import React, { useCallback, useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import CricketScoreboard from "./CricketScoreboard";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";
import { ChartNetwork } from "lucide-react";
import Cookies from "js-cookie";

const Cricket = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  const [back3, setBack3] = useState([]);
  const [lay3, setLay3] = useState([]);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);
    const [bookMaker, setBookMaker] = useState([]);
  const [active, setActive] = useState(false);
  const [selectFancy, setSelectFancy] = useState("");
  const [status, setStatus] = useState(0);
  const [side, setSide] = useState("");
  const [fancyValue, setFancyValue] = useState(0);
  const [newactive, setNewActive] = useState(0);
  const [isExpanded, setIsExpanded] = useState(1);
  const [isExpanded1, setIsExpanded1] = useState(1);
  const [isExpanded2, setIsExpanded2] = useState(1);
  const [isExpanded3, setIsExpanded3] = useState(1);
  const [isExpanded4, setIsExpanded4] = useState(1);
  const [isExpanded5, setIsExpanded5] = useState(1);
  const [isExpanded6, setIsExpanded6] = useState(1);
  const [fancyData, setFancyData] = useState();
  const [backLoading, setBackLoading] = useState(false);
  const [layLoading, setLayLoading] = useState(false);
  const [book1Loading, setBook1Loading] = useState(false);
  const [book2Loading, setBook2Loading] = useState(false);
  const [fancy1Loading, setFancy1Loading] = useState(false);
  const [fancy2Loading, setFancy2Loading] = useState(false);

  const [oddsDelay, setOddsDelay] = useState();
  const [bookMakerDelay, setBookMakerDelay] = useState();
  const [miniBookMakerDelay, setMiniBookMakerDelay] = useState();
  const [fancyDelay, setFancyDelay] = useState();
  const [tossDelay, setTossDelay] = useState();
  const [rate, setRate] = useState("");

  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);

  const [marketId, setMarketId] = useState(() => {
    return sessionStorage.getItem("marketId") || "";
  });

  const [matchLiabilities, setMatchLiabilities] = useState();
  const [oddMatchLiablity, setOddMatchLiablity] = useState();

  const [runner1, setRunner1] = useState(() => {
    return sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return sessionStorage.getItem("runner2") || "";
  });

  const [runner3, setRunner3] = useState(() => {
    return sessionStorage.getItem("runner3") || "";
  });

  const [selectedId, setSelectedId] = useState(0);
  const [runner, setRunner] = useState("");
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [nat, setnat] = useState("");

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");
  const selectionid3 = sessionStorage.getItem("selectionid3");
  const eventId = sessionStorage.getItem("eventid");
  const [channel, setChannel] = useState();

  const role = localStorage?.getItem("username");
  const token = Cookies.get("rb_session"); // session flag; the session itself is HttpOnly (#14)

  useEffect(() => {
    if (eventId) {
      setChannel(eventId);
    }
  }, []); // run once on mount
  const [fancy, setFancy] = useState([]);

  const [selectedMarket, setSelectedMarket] = useState();
  const [fancyBet, setFancyBet] = useState(0);
  const [fancymarket, setFancyMarket] = useState(0);
  const [fancyOdd, setFancyOdd] = useState(0);
  const [fancyXtra, setFancyXtra] = useState(0);
  const [selectedBet, setSelectedBet] = useState(0);
  const [stake, setStake] = useState(0);
  const [startTime, setStartTime] = useState();

  /* Arriving from a TV / BM / F shortcut on /inplay: scroll to that
     section once it has rendered (markets arrive after the first paint,
     so keep looking for a few seconds). */
  useEffect(() => {
    const section = sessionStorage.getItem("rb_jump");
    if (!section) return undefined;
    sessionStorage.removeItem("rb_jump");
    const id =
      section === "bookmaker" ? "rb-bookmaker" : section === "fancy" ? "rb-fancy" : "rb-match-top";
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      if (el || ++tries > 30) {
        clearInterval(timer);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 250);
    return () => clearInterval(timer);
  }, []);
  const [book1, setBook1] = useState([]);
  const [book2, setBook2] = useState([]);

  const [bok1lay, setBok1lay] = useState([]);
  const [bok2back, setBok2back] = useState([]);
  const [bok1back, setBok1back] = useState([]);
  const [bok2lay, setBok2lay] = useState([]);
  const [minibook1, setMiniBook1] = useState([]);
  const [minibook2, setMiniBook2] = useState([]);

  const [minibok1lay, setMiniBok1lay] = useState([]);
  const [minibok2back, setMiniBok2back] = useState([]);
  const [minibok1back, setMiniBok1back] = useState([]);
  const [minibok2lay, setMiniBok2lay] = useState([]);

  const [betData, setBetData] = useState([]);
  const [fancyBetData, setFancyBetData] = useState([]);
  const [bookmakerProfit, setBookMakerProfit] = useState(0);
  const [toss1, setToss1] = useState();
  const [toss2, setToss2] = useState();
  const [play, setPlay] = useState(false);
  const [mini1, setMini1] = useState([]);
  const [mini2, setMini2] = useState([]);
  const [oddEven, setOddEven] = useState([]);
  const [session, setSession] = useState([]);
  const [allfancy, setAllfacy] = useState([]);
  const [wpMarket, setWPMarket] = useState([]);
  const [fancySrno, setFancySrno] = useState(0);
  const [minOdds, setMinOdds] = useState(0);
  const [minBookmaker, setMinBookmaker] = useState(0);
  const [minMiniBook, setMinMiniBook] = useState(0);
  const [minFancy, setMinFancy] = useState(0);
  const [maxOdds, setMaxOdds] = useState(0);
  const [maxBookmaker, setMaxBookmaker] = useState(0);
  const [maxMiniBook, setMaxMiniBook] = useState(0);
  const [maxFancy, setMaxFancy] = useState(0);
  const [unmatch, setUnmatch] = useState([]);
  const { themeColors } = useTheme();

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 769);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(6, 1fr)" : "repeat(12, 1fr)",
    gap: "5px",
  };

  // bet form data
  const [formData, setFormData] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    status: 0,
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // fancy bet form data
  const [formData1, setFormData1] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "fancy",
    betAmount: 0,
    srno: "",
    value: 0,
    rate: 0,
    side: "",
    status: 0,
    sportName: "cricket",
  });

  // book maker bet form
  const [formData2, setFormData2] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "book maker",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // toss bet
  const [formData3, setFormData3] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "toss",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });

  // mini book maker
  const [formData4, setFormData4] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "mini_bookmaker",
    betAmount: 0,
    profit: 0,
    side: "",
    sportName: "cricket",
    team1: runner1,
    team2: runner2,
  });
  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  function convertDecimalToInteger(decimalValue) {
    // Get the integer part
    const integerPart = Math.floor(decimalValue);

    // Get the decimal part
    const decimalPart = decimalValue - integerPart;

    // Apply the rule
    if (decimalPart >= 0.5) {
      return integerPart + 1; // Round up
    } else {
      return integerPart; // Round down
    }
  }

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handleChangeStake = (action) => {
    setStake((prev) => {
      let newMoney = prev <= 0 ? 0 : prev;

      if (action === 0) {
        return parseFloat(newMoney) + 100;
      } else {
        return parseFloat(newMoney) - 100;
      }
    });
  };

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  const handlefancyChange = (action) => {
    setSelectedMarket((prev) => {
      let newMoney = prev <= 1 ? 1 : prev;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 1);
      } else {
        return parseFloat(newMoney) + 1;
      }
    });
  };

  useEffect(() => {
    // const getTimeDelay = async () => {
    //   try {
    //     const response = await axios.get(
    //       base_url + "/get/api/webapi/sportsData/timeDelay",
    //       {
    //         params:{
    //           eventId
    //         },
    //         withCredentials: true,
    //         headers: {
    //           "content-type": "application/json",
    //         },
    //       }
    //     );

    //     console.log(response.data.betDelay[0].book_maker_cricket, "responseeefe");
    //     if (response?.data.success) {
    //       if (response?.data.betDelay.length > 0) {
    //         let timeDelayData = response?.data.betDelay;
    //         const delays = timeDelayData[0] || "";

    //         const oddss = JSON.parse(delays?.match_odds_cricket);
    //         const oddsDelay = oddss?.bet_delay || 0;
    //         const minBet = oddss?.min_bet || 0;
    //         const maxBet = oddss?.max_bet || 0;
    //         // console.log(minBet);
    //         setMinOdds(minBet);
    //         setMaxOdds(maxBet);
    //         setOddsDelay(oddsDelay * 1000);

    //         const bookMaker = JSON.parse(delays?.book_maker_cricket);
    //         const bookMakerDelay = bookMaker?.bet_delay || 0;
    //         const minBook = bookMaker?.min_bet || 0;
    //         const maxBook = bookMaker?.max_bet || 0;
    //         setMinBookmaker(minBook);
    //         setMaxBookmaker(maxBook);
    //         setBookMakerDelay(bookMakerDelay * 1000);

    //         const miniBookMaker = JSON.parse(delays?.mini_book_maker_cricket);
    //         const miniBookMakerDelay = miniBookMaker?.bet_delay || 0;
    //         const miniMin = miniBookMaker?.min_bet || 0;
    //         const miniMax = miniBookMaker?.max_bet || 0;
    //         setMinMiniBook(miniMin);
    //         setMaxMiniBook(miniMax);
    //         setMiniBookMakerDelay(miniBookMakerDelay * 1000);

    //         const fancy = JSON.parse(delays?.fancy_cricket);
    //         const fancyDelay = fancy?.bet_delay || 0;
    //         const miniFancy = fancy?.mini_bet || 0;
    //         const maxFancy = fancy?.max_bet || 0;
    //         setMinFancy(miniFancy);
    //         setMaxFancy(maxFancy);
    //         setFancyDelay(fancyDelay * 1000);

    //         const toss = JSON.parse(delays?.to_win_the_toss_cricket);
    //         const tossDelay = toss?.bet_delay || 0;
    //         setTossDelay(tossDelay * 1000);

    //         // const minBet= JSON.parse(delays?.to_win_the_toss_cricket);
    //       }
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };

    const getTimeDelay = async () => {
      try {
        const res = await axios.get(
          `${base_url}/get/api/webapi/sportsData/timeDelay`,
          {
            params: { eventId },
            withCredentials: true,
            headers: { "content-type": "application/json" },
          }
        );

        const rawDelays = res?.data?.betDelay?.[0]?.delays;
        // console.log("raw delays:", rawDelays);

        // Helper: only use default when value is undefined/null/empty/invalid number.
        const parseNumber = (val, defaultVal) => {
          // console.log('values',val);
          if (val === undefined || val === null) return defaultVal;
          if (typeof val === "string" && val.trim() === "") return defaultVal;
          const n = Number(val);
          return Number.isFinite(n) ? n : defaultVal;
        };

        // If response has no delays object at all, rawDelays will be undefined -> use {} and defaults below.
        const delays = JSON.parse(rawDelays) || {};
        // console.log('delays',delays);

        // Odds
        const parsedMinOdds = parseNumber(delays?.min_bet, 100);
        const parsedMaxOdds = parseNumber(delays?.max_bet, 10000);
        const parsedOddsDelaySec = parseNumber(delays?.bet_delay, 5);

        setMinOdds(parsedMinOdds);
        setMaxOdds(parsedMaxOdds);
        setOddsDelay(parsedOddsDelaySec * 1000);

        // Bookmaker
        const parsedMinBook = parseNumber(delays?.min_book_bet, 100);
        const parsedMaxBook = parseNumber(delays?.max_book_bet, 10000);
        const parsedBookDelaySec = parseNumber(delays?.bet_book_delay, 5);

        setMinBookmaker(parsedMinBook);
        setMaxBookmaker(parsedMaxBook);
        setBookMakerDelay(parsedBookDelaySec * 1000);

        // Mini bookmaker
        const parsedMinMini = parseNumber(delays?.min_mini_bet, 100);
        const parsedMaxMini = parseNumber(delays?.max_mini_bet, 10000);
        const parsedMiniDelaySec = parseNumber(delays?.bet_mini_delay, 5);

        setMinMiniBook(parsedMinMini);
        setMaxMiniBook(parsedMaxMini);
        setMiniBookMakerDelay(parsedMiniDelaySec * 1000);

        // Fancy
        const parsedMinFancy = parseNumber(delays?.min_fancy_bet, 100);
        const parsedMaxFancy = parseNumber(delays?.max_fancy_bet, 10000);
        const parsedFancyDelaySec = parseNumber(delays?.bet_fancy_delay, 5);

        setMinFancy(parsedMinFancy);
        setMaxFancy(parsedMaxFancy);
        setFancyDelay(parsedFancyDelaySec * 1000);

        // Toss (may be a JSON string or object)
        let parsedTossDelaySec = 0;
        if (
          delays.to_win_the_toss_cricket !== undefined &&
          delays.to_win_the_toss_cricket !== null
        ) {
          try {
            const tossObj =
              typeof delays.to_win_the_toss_cricket === "string"
                ? JSON.parse(delays.to_win_the_toss_cricket)
                : delays.to_win_the_toss_cricket;
            parsedTossDelaySec = parseNumber(tossObj?.bet_delay, 0);
          } catch (err) {
            console.warn("Failed to parse to_win_the_toss_cricket:", err);
            parsedTossDelaySec = 0;
          }
        }
        setTossDelay(parsedTossDelaySec * 1000);

        // Debug log of parsed values (so you can confirm)
        // console.log("parsed values:",
        //   {
        //     minOdds: parsedMinOdds, maxOdds: parsedMaxOdds, oddsDelayMs: parsedOddsDelaySec * 1000,
        //     minBook: parsedMinBook, maxBook: parsedMaxBook, bookDelayMs: parsedBookDelaySec * 1000,
        //     minMini: parsedMinMini, maxMini: parsedMaxMini, miniDelayMs: parsedMiniDelaySec * 1000,
        //     minFancy: parsedMinFancy, maxFancy: parsedMaxFancy, fancyDelayMs: parsedFancyDelaySec * 1000,
        //     tossDelayMs: parsedTossDelaySec * 1000
        //   }
        // );
      } catch (err) {
        console.error("getTimeDelay error:", err);
        // safe fallback to defaults
        setMinOdds(100);
        setMaxOdds(10000);
        setOddsDelay(0);
        setMinBookmaker(100);
        setMaxBookmaker(10000);
        setBookMakerDelay(0);
        setMinMiniBook(100);
        setMaxMiniBook(10000);
        setMiniBookMakerDelay(0);
        setMinFancy(100);
        setMaxFancy(10000);
        setFancyDelay(0);
        setTossDelay(0);
      }
    };

    getTimeDelay();
  }, []);

  const betDataa = async () => {
    // Player-only endpoints (401 for a guest): skip them when logged out.
    if (!isAuthenticated) return;
    try {
      const response = await axios.post(
        base_url + "/api/webapi/betData",
        { eventId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log("databet", response);

      if (response?.data.success) {
        const sportsBets = response?.data.sportsBets;
        const fancyBets = response?.data.fancyBets;
        const unmach = response?.data.unmatch;
        // console.log('ddd',data);
        setBetData(sportsBets);
        setFancyBetData(fancyBets);
        setUnmatch(unmach);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // formdata odds
  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (Number(money) < Number(minOdds)) {
      toast.error("Bet can't be placed for less than min value");
      return;
    }

    if (Number(money) > Number(maxOdds)) {
      toast.error("Bet can't be placed for greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selected price is too low");
      return;
    }

    // ✅ Ensure `oddsDelay` has a valid value
    const delay = oddsDelay || 0;

    if (delay > 0) {
      if (side === "Back") {
        setBackLoading(true);
        setLayLoading(false);
      } else if (side === "Lay") {
        setLayLoading(true);
        setBackLoading(false);
      }
    }

    setTimeout(async () => {
      try {
        if (side === "Back") {
          const allBackPrices = [...back1, ...back2, ...back3];
          const valueExists = allBackPrices.some(
            (bac) => bac.price === selectedPrice
          );

          if (valueExists === false) {
            toast.error("Bet placed to unmatched due to value change");
            return;
          }

          if (!valueExists) {
            try {
              const response = await axios.post(
                base_url + "/api/webapi/unmatched",
                formData,
                {
                  withCredentials: true,
                  headers: {
                    "content-type": "application/json",
                  },
                }
              );

              if (response?.data.success) {
                toast.error("Bet placed to unmatched due to value change");
                setbackActive(0);
                setlayActive(3);
                setSelectedBet(0);
                betDataa();
              }
            } catch (err) {
              console.log(err);
            } finally {
              if (delay > 0) setBackLoading(false);
              setLayLoading(false);
            }
            return;
          }
        }

        if (side === "Lay") {
          const allLayPrices = [...lay1, ...lay2, ...lay3];
          const valueExists = allLayPrices.some(
            (lay) => lay.price === selectedPrice
          );

          if (valueExists === false) {
            toast.error("Bet placed to unmatched due to value change");
            return;
          }

          if (!valueExists) {
            try {
              const response = await axios.post(
                base_url + "/api/webapi/unmatched",
                formData,
                {
                  withCredentials: true,
                  headers: {
                    "content-type": "application/json",
                  },
                }
              );

              if (response?.data.success) {
                toast.error("Bet placed to unmatched due to value change");
                setbackActive(0);
                setlayActive(3);
                setSelectedBet(0);
                betDataa();
              }
            } catch (err) {
              console.log(err);
            } finally {
              if (delay > 0) setBackLoading(false);
              setLayLoading(false);
            }
            return;
          }
        }

        try {
          const response = await axios.post(
            `${base_url}/api/webapi/sportsData`,
            formData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json",
              },
            }
          );

          if (response?.data.success) {
            toast.success(response?.data.message);
            setbackActive(0);
            setlayActive(3);
            setSelectedBet(0);
            betDataa();
            getMatchLiabilities();
          } else {
            toast.error(response?.data.message);
          }
        } catch (err) {
          console.error(err);
          toast.error("Failed to place bet");
        }
      } finally {
        // 🔹 Ensure loading stops after delay+request
        if (delay > 0) setBackLoading(false);
        setLayLoading(false);
      }
    }, delay);
  };

  // formdata2 bookmaker
  const handleSubmit2 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if (isTenMinutesRemaining(startTime)) {
    //   toast.error("Off Bets! Bets placed only before ten minutes");
    //   return;
    // }

    if (Number(money) < Number(minBookmaker)) {
      toast.error("Bet cant be placed less min value");
      return;
    }
    if (Number(money) > Number(maxBookmaker)) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `bookMakerDelay` has a valid value
    const delay = bookMakerDelay || 0;

    if (delay > 0) {
      if (side === "Back") {
        setBook1Loading(true);
        setBook2Loading(false);
      } else if (side === "Lay") {
        setBook2Loading(true);
        setBook1Loading(false);
      }
    }

    setTimeout(async () => {
      const combinedData = [bok1back, bok1lay, bok2back, bok2lay];

      console.log("combinedData:", combinedData);

      if (combinedData.includes(selectedPrice) === false) {
        toast.error("Bet placed to unmatched due to value change");
        return;
      }

      console.log("selectedPrice:", selectedPrice);

      if (!combinedData.includes(selectedPrice)) {
        try {
          const response = await axios.post(
            base_url + "/api/webapi/unmatched",
            formData2,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json",
              },
            }
          );
          console.log("unmatched response:", response);   

          if (response?.data.success) {
            toast.error("Bet placed to unmatched due to value change");
            setbackActive(0);
            setlayActive(3);
            setSelectedBet(0);
            betDataa();
          }
        } catch (err) {
          console.log(err);
        } finally {
          if (delay > 0) setBook1Loading(false);
          setBook2Loading(false);
        }

        return;
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData2,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          setbackActive(0);
          setlayActive(3);
          setSelectedBet(0);
          betDataa();
          getMatchLiabilities();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      } finally {
        if (delay > 0) setBook1Loading(false);
        setBook2Loading(false);
      }
    }, delay);
  };

  // formdata1 fancy
  const handleSubmit3 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (stake < minFancy) {
      toast.error("Bet can't be placed less than min value");
      return;
    }
    if (stake > maxFancy) {
      toast.error("Bet can't be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selected price is less");
      return;
    }

    // ✅ Ensure fancyDelay has a valid value
    const delay = fancyDelay || 0;
    // console.log("FormData before submit:", formData1);

    if (delay > 0) {
      if (side === "yes") {
        setFancy1Loading(true);
        setFancy2Loading(false);
      } else if (side === "no") {
        setFancy2Loading(true);
        setFancy1Loading(false);
      }
    }

    setTimeout(async () => {
      try {
        // ✅ Normalize all rates safely
        const allRates = fancyData
          ?.map((fancy) => {
            try {
              if (!fancy?.rate) return [];

              if (typeof fancy.rate === "string") {
                const parsed = JSON.parse(fancy.rate);
                return Object.values(parsed);
              }

              if (typeof fancy.rate === "object") {
                return Object.values(fancy.rate);
              }

              if (typeof fancy.rate === "number") {
                return [fancy.rate];
              }

              return [];
            } catch (e) {
              console.error("Invalid rate format:", fancy?.rate);
              return [];
            } finally {
              if (delay > 0) setFancy1Loading(false);
              setFancy2Loading(false);
            }
          })
          .flat()
          .filter(Boolean);

        // console.log("allRates:", allRates);

        // 🔍 Optional unmatched check
        // if (!allRates.includes(selectedMarket)) {
        //   try {
        //     const response = await axios.post(
        //       `${base_url}/api/webapi/unmatched`,
        //       formData1,
        //       {
        //         withCredentials: true,
        //         headers: { "content-type": "application/json" },
        //       }
        //     );

        //     if (response?.data.success) {
        //       toast.error("Bet placed to unmatched due to value change");
        //       betDataa();
        //     }
        //   } catch (err) {
        //     console.error("Unmatched bet error:", err);
        //   }
        //   return;
        // }

        // ✅ Place bet request
        const response = await axios.post(
          `${base_url}/api/webapi/sportsFancyData`,
          formData1,
          {
            withCredentials: true,
            headers: { "content-type": "application/json" },
          }
        );

        if (response?.data.success) {
          toast.success(response?.data.message);
          setbackActive(0);
          setlayActive(3);
          setSelectedBet(0);
          betDataa();
          getMatchLiabilities();
        } else {
          toast.error(response?.data.message || "Bet failed");
        }
      } catch (err) {
        console.error("Bet placement error:", err);
        toast.error("Failed to place bet");
      } finally {
        if (delay > 0) setFancy1Loading(false);
        setFancy2Loading(false);
      }
    }, delay);
  };
  const calculatePnLByMarket = (bets, team1, team2) => {
    const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
    const result = {};

    marketTypes.forEach((market) => {
      const marketBets = bets?.filter((b) => {
        const betType = b?.type
          ?.toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "");
        return betType === market;
      });

      const runnerPnl = {};

      // Collect unique runners
      const runners = new Set(marketBets.map((b) => b.runnerName));
      runners.add(team1);
      runners.add(team2);
      // Check if runner3 (i.e., "The Draw") exists in sessionStorage
      const runner3 = sessionStorage.getItem("runner3");
      if (runner3 && runner3.toLowerCase() === "the draw") {
        runners.add("The Draw");
      }

      // Initialize PnL
      for (const runner of runners) {
        runnerPnl[runner] = 0;
      }

      // Calculate PnL
      marketBets?.forEach(({ runnerName, side, betprice, betAmount }) => {
        const odds = parseFloat(betprice);
        const stake = parseFloat(betAmount);

        // console.log(marketBets[0].type, "marketBets");

        for (const currentRunner of runners) {
          if (marketBets[0].type === "book maker") {
            console.log(currentRunner, "currentRunner");
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (stake * odds) / 100;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (stake * odds) / 100;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          } else {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (odds - 1) * stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (odds - 1) * stake;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          }
        }
      });

      // Round to 2 decimal places
      Object.keys(runnerPnl).forEach((runner) => {
        runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
      });

      // Calculate liability (worst case)
      const liability = Object.values(runnerPnl).length
        ? Math.min(...Object.values(runnerPnl))
        : 0;

      result[market] = {
        pnl: runnerPnl,
        liability: parseFloat(liability.toFixed(2)),
      };
    });

    return result;
  };

  const getMatchLiabilities = async () => {
    // Player-only endpoints (401 for a guest): skip them when logged out.
    if (!isAuthenticated) return;
    try {
      const response = await axios.get(
        `${base_url}/api/webapi/getMatchLiablity/${eventId}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const bets = response.data.liabilities || []; // ✅ fix here

      // console.log(bets, "bets after fix");

      const { team1, team2 } = bets[0] || {};

      const result = calculatePnLByMarket(bets, team1, team2);

      // console.log(result, "bets result");

      setMatchLiabilities(result);
    } catch (error) {
      console.error("Error fetching match liabilities:", error);
    }
  };

  useEffect(() => {
    getMatchLiabilities();
  }, []);

  const calculateFancyPositions = (bets, targetRate) => {
    let position = 0;

    bets.forEach((bet) => {
      const betRate = parseFloat(bet?.betprice);
      const betAmount = parseFloat(bet?.betAmount);
      const rate = Math.abs(parseFloat(bet?.rate)); // always positive
      // const rate = oldRate > 0 ? -oldRate : oldRate;

      // const rate = oldRate < 0 ? -oldRate : oldRate;



      if (bet.side === "no") {
        // lay bet
        if (targetRate >= betRate) {
          // Lay bet loses - we pay out the liability (stake amount)
          position -= rate;
        } else {
          // Lay bet wins - we keep the stake
          position += betAmount;
        }
      } else if (bet.side === "yes") {
        // back bet
        if (targetRate >= betRate) {
          // Back bet wins - we get profit (stake amount for fancy bets)
          position += rate;
        } else {
          // Back bet loses - we lose the stake
          position -= betAmount;
        }
      }
    });

    return position;
  };

  const calculateOverallPosition = (nat, fancyBetData) => {
    const betsForFancy = fancyBetData.filter(
      (bet) => bet.runnerName === nat
    );
    if (betsForFancy.length === 0) return { profit: 0, loss: 0 };

    // Get the current rate for this fancy (assuming it's available)
    const currentRate = betsForFancy[0]?.betprice || 0;

    // console.log(currentRate, "currentRate");

    // Calculate best case and worst case scenarios
    let bestCase = -Infinity;
    let worstCase = Infinity;

    // Check positions for a range of possible outcomes
    for (
      let rate = parseFloat(currentRate) - 10;
      rate <= parseFloat(currentRate) + 10;
      rate++
    ) {
      // console.log(rate, "rate");

      const position = calculateFancyPositions(betsForFancy, rate);

      // console.log(position,"postion")

      bestCase = Math.max(bestCase, position);
      worstCase = Math.min(worstCase, position);
    }

    return {
      profit: bestCase > 0 ? bestCase : 0,
      loss: worstCase < 0 ? worstCase : 0,
    };
  };

  // formdata4 toss
  const handleSubmit4 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    if (money < 100) {
      toast.error("Bet cant be placed less than Rs.100");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `tossDelay` has a valid value
    const delay = tossDelay || 0;

    setTimeout(async () => {
      // const combinedData = [
      //   toss1.back_price, toss1.lay_price,
      //   toss2.back_price, toss2.lay_price
      // ];

      // if (!combinedData.includes(selectedPrice)) {
      //   toast.error("Bet can't be placed due to value change");
      //   return;
      // }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData3,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  // minibookmaker
  const handleSubmit5 = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if (isTenMinutesRemaining(startTime)) {
    //   toast.error("Off Bets! Bets placed only before ten minutes");
    //   return;
    // }

    if (money < minMiniBook) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (money > maxMiniBook) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // ✅ Ensure `miniBookMakerDelay` has a valid value
    const delay = miniBookMakerDelay || 0;

    setTimeout(async () => {
      const combinedData = [
        mini1.back_price,
        mini1.lay_price,
        mini2.back_price,
        mini2.lay_price,
      ];

      if (!combinedData.includes(selectedPrice)) {
        try {
          const response = await axios.post(
            base_url + "/api/webapi/unmatched",
            formData4,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json",
              },
            }
          );

          if (response?.data.success) {
            toast.error("Bet placed to unmatched due to value change");
            betDataa();
          }
        } catch (err) {
          console.log(err);
        }

        return;
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData4,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log('formmatch',response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          betDataa();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      }
    }, delay);
  };

  useEffect(() => {
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setRunner1(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner2(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setMarketId(location.state.runner2);
    }

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    const fancyprofit = () => {
      const prff = (parseFloat(selectedPrice) * parseFloat(money)) / 100;

      // console.log('fancc',prff);
      const value = convertDecimalToInteger(prff);

      setBookMakerProfit(value);
    };

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();
    fancyprofit();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);

  // console.log(channel)

  useEffect(() => {
    window.scrollTo(0, 0);
    const fancyData = async () => {
  try {

    const competitionId = sessionStorage.getItem("eventid");

    const response = await axios.get(
      `${base_url}/api/webapi/getFancy/${competitionId}`
    );

    if (response?.data?.data && Array.isArray(response.data.data)) {

      const fetchedData = response.data.data;

      console.log(fetchedData, "fetchdata");

      // ODD EVEN
      const oddData = fetchedData.filter(
        (item) => item.gtype === "oddeven"
      );

      // SESSION
      const sess = fetchedData.filter(
        (item) =>
          item.gtype === "fancy" &&
      
          item.mname !== "Ball By Ball"
      );

      // WICKET / FALL / BOUNDARY
      const wp = fetchedData.filter((item) =>
        item.mname.includes("Fall") ||
        item.mname.includes("Boundaries") ||
        item.mname.includes("Wicket")
      );

      // MAIN FANCY
      const mtch = fetchedData.filter(
        (item) => item.gtype === "fancy1"
      );

      // // console.log(fetchedData, "fetchedData");

      setFancyData(fetchedData);

      // console.log(sess, "oddsessdata");
      setSession(sess);
      setOddEven(oddData);
      setWPMarket(wp);
      setFancy(mtch);

    } else {

      setFancy([]);

    }

  } catch (err) {

    console.error("Error fetching fancy data:", err);
    setFancy([]);

  }
};
   const bookMakerData = async () => {
  try {

    const competitionId = sessionStorage.getItem("eventid");

    const response = await axios.get(
      `${base_url}/api/webapi/getBookMaker/${competitionId}`
    );

    // console.log("Full API Response:", response.data);

    if (response?.data?.data && Array.isArray(response.data.data)) {

      const fetchedData = response.data.data;


      // console.log(fetchedData, "bookmakerfetchdata");

     
        const Bookmaker = fetchedData.find(
        (item) => item.mname === "Bookmaker"
      );

      // console.log(Bookmaker, "bookmaker");


      const runner1 = Bookmaker?.section?.[0];
      const runner2 = Bookmaker?.section?.[1];


      setBookMaker(Bookmaker);

      setBook1(runner1);
      setBook2(runner2);

      // console.log(runner1, "runner1");
      // console.log(runner2, "runner2");

 

    }

  } catch (err) {

    console.error("Error fetching bookmaker data:", err);

  }
};


    const minibookMakerData = async () => {
      try {
        const competitionId = sessionStorage.getItem("eventid");

        const response = await axios.get(
          base_url + "/api/webapi/getBookMaker",
          {
            params: { competitionId: competitionId },
          }
        );

        // console.log("API Response:", response?.data);

        const bookmaker = response?.data?.data?.data;

        if (Array.isArray(bookmaker) && bookmaker.length > 0) {
          // Find "Bookmaker" market
          const bookMarket = bookmaker.find(
            (m) => m.mname === "Mini_Bookmaker"
          );

          if (bookMarket) {
            // console.log("miniBookmaker Market:", bookMarket);

            // Example: extract first team odds from section[0]
            const team1 = bookMarket.section?.[0];
            const team2 = bookMarket.section?.[1];

            const team1Back = team1?.odds?.find((o) => o.oname === "back1");
            const team1Lay = team1?.odds?.find((o) => o.oname === "lay1");

            const team2Back = team2?.odds?.find((o) => o.oname === "back1");
            const team2Lay = team2?.odds?.find((o) => o.oname === "lay1");
            // console.log(team1.gstatus, "cnen");
            // console.log("Team1 Back:", team1Back?.odds, "Lay:", team1Lay?.odds);
            // console.log("Team2 Back:", team2Back?.odds, "Lay:", team2Lay?.odds);

            // Now set in state
            setMiniBook1(team1); // team name
            setMiniBook2(team2);
            setMiniBok1back(team1Back?.odds);
            setMiniBok1lay(team1Lay?.odds);
            setMiniBok2back(team2Back?.odds);
            setMiniBok2lay(team2Lay?.odds);
          }
        } else {
          setFancy([]);
        }

        // Optionally set fancy if available
        if (Array.isArray(fancy)) {
          setFancy(fancy);
        }
      } catch (err) {
        console.error("Error fetching bookmaker data:", err);
        setFancy([]);
      }
    };

    const tossData = async () => {
      try {
        const competitionId = sessionStorage.getItem("eventid");

        const response = await axios.get(
          base_url + "/api/webapi/getBookMaker",
          {
            params: { competitionId: competitionId },
          }
        );

        // console.log("API Response:", response?.data);

        const bookmaker = response?.data?.data?.data;

        if (Array.isArray(bookmaker) && bookmaker.length > 0) {
          // Find "Bookmaker" market
          const bookMarket = bookmaker.find((m) => m.mname === "");

          if (bookMarket) {
            // console.log("miniBookmaker Market:", bookMarket);

            // Example: extract first team odds from section[0]
            const team1 = bookMarket.section?.[0];
            const team2 = bookMarket.section?.[1];

            const team1Back = team1?.odds?.find((o) => o.oname === "back1");
            const team1Lay = team1?.odds?.find((o) => o.oname === "lay1");

            const team2Back = team2?.odds?.find((o) => o.oname === "back1");
            const team2Lay = team2?.odds?.find((o) => o.oname === "lay1");
            // console.log(team1.gstatus,"cnen")
            // console.log("Team1 Back:", team1Back?.odds, "Lay:", team1Lay?.odds);
            // console.log("Team2 Back:", team2Back?.odds, "Lay:", team2Lay?.odds);

            // Now set in state
            setMiniBook1(team1); // team name
            setMiniBook2(team2);
            setMiniBok1back(team1Back?.odds);
            setMiniBok1lay(team1Lay?.odds);
            setMiniBok2back(team2Back?.odds);
            setMiniBok2lay(team2Lay?.odds);
          }
        } else {
          setFancy([]);
        }

        // Optionally set fancy if available
        if (Array.isArray(fancy)) {
          setFancy(fancy);
        }
      } catch (err) {
        console.error("Error fetching bookmaker data:", err);
        setFancy([]);
      }
    };

    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("reeesyy", response);
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        const status3 = response?.data.result[2]?.status;
        // console.log(status1);
        // console.log(status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }

        if (status3 === "ACTIVE") {
          const backk2 = response?.data.result[2]?.ex?.availableToBack;
          const layy2 = response?.data.result[2]?.ex?.availableToLay;

          setBack3(backk2);
          setLay3(layy2);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = () => {
      fancyData();
      bookMakerData();
      // minibookMakerData();
      // tossData();
      backLay();
    };

    betDataa();

    const intervalId = setInterval(updateData, 500);

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // console.log('matchess',wpMarket);

  // console.log('bok2',book2)
  // betformdata
  formData.selectionId = selectedId;
  formData.runnername = runner;
  formData.betAmount = money;
  formData.profit = profit;
  formData.eventid = eventId;
  formData.betPrice = selectedPrice;
  formData.side = side;

  // foemdata1
  formData1.eventid = eventId;
  formData1.runnername = selectFancy;
  formData1.betAmount = stake;
  formData1.betPrice = fancyValue;
  formData1.side = side;
  formData1.value = fancyValue;
  formData1.rate = rate;
  formData1.srno = fancySrno;

  // formdata2
  formData2.eventid = eventId;
  formData2.runnername = runner;
  formData2.betAmount = money;
  formData2.profit = bookmakerProfit;
  formData2.betPrice = selectedPrice;
  formData2.selectionId = selectedId;
  formData2.side = side;

  // formdata3
  formData3.eventid = eventId;
  formData3.runnername = runner;
  formData3.betAmount = money;
  formData3.profit = bookmakerProfit;
  formData3.betPrice = selectedPrice;
  formData3.selectionId = selectedId;
  formData3.side = side;

  const generateModalTableData = (nat, fancyBetData) => {
    const betsForFancy = fancyBetData.filter(
      (bet) => bet.runnerName === nat
    );
    if (betsForFancy.length === 0) return [];

    // Get the range of rates from bets
    const rates = betsForFancy.map((bet) => parseFloat(bet.betprice));
    const minRate = Math.min(...rates);
    const maxRate = Math.max(...rates);

    // Generate table data for rate-1, rate, rate+1 for each bet
    const tableData = [];
    const processedRates = new Set();

    rates.forEach((rate) => {
      [rate - 1, rate, rate + 1].forEach((targetRate) => {
        if (!processedRates.has(targetRate)) {
          processedRates.add(targetRate);
          const position = calculateFancyPositions(betsForFancy, targetRate);
          tableData.push({
            rate: targetRate,
            position: position,
          });
        }
      });
    });

    // Sort by rate
    return tableData.sort((a, b) => a.rate - b.rate);
  };

  return (
    <>
      {<LoginReg active={active} setactive={setActive} />}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
        <div _ngcontent-jrx-c101="" className="rightbar">
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">
              <Header
                isSidebar={isSidebar}
                setSidebar={setSidebar}
                show={showCanvas}
                handleShow={handleCanvasShow}
                handleClose={handleCanvasClose}
              />
              <div _ngcontent-jrx-c95="" className="body-container mb-5">
                <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />

                <div
                  _ngcontent-jrx-c95=""
                  className="rightbar d-flex flex-column"
                  style={{
                    paddingLeft: isLargeScreen ? "0px" : "0px",
                    paddingRight: isLargeScreen ? "3px" : "0px",
                    width: isSidebar ? "" : "2500%",
                    transition: "width 0.3s ease-in-out",
                  }}
                >
                  {/* <div className="news-bar">
                    <marquee style={{ width: "100%" }}>
                      <p className="m-0 w-100">
                        👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY
                        DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR
                        SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT
                        HELPDESK NO +265899881378
                      </p>
                    </marquee>
                  </div> */}

                  <div className=" d-flex flex-column flex-lg-row justify-content-between mainn w-100 rb-match">
                    <div
                      className="match-content"
                      style={{ backgroundColor: "var(--dark-theme-data-bg)" }}
                    >
                      <div className="d-flex gap-5 align-items-center">
                        {/* <span>Time Remaining: </span> */}
                      </div>

                      {role !== "demo" && token && (
                        <div
                          className="
                            livetvv position-relative"
                        >
                          <div
                            className="p-2 cursor-pointer d-flex justify-content-between bg-black"
                            onClick={() => setPlay(!play)}
                          >
                            <div>
                              <span>
                                <i
                                  className="bi bi-broadcast fs-16"
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                  }}
                                ></i>
                              </span>
                              <span> Watch Live Match</span>
                            </div>
                            <div>
                              <button className="live-stream-button ng-star-inserted">
                                Watch Live
                              </button>
                            </div>
                          </div>

                          {play && channel && (
                            <iframe
                              title="Live TV"
                              className="border w-100 "
                              style={{ height: "26vh" }}
                              // src={`https://cache.bpexchanges.com/embed?eventId=${channel}`}
                              src={`/proxy-stream/${channel}`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
                          )}
                        </div>
                      )}

                      {/* <iframe
                        src={`https://trovetown.co/score/sportRadar/?eventId=${sessionStorage.getItem(
                          "eventid"
                        )}`}
                        style={{
                          width: "100%",
                          height: "200px",
                          border: "none",
                        }}
                        title="Live Scoreboard"
                      /> */}

                      {role !== "demo" && token && 
                      
                      
                      
                <iframe
  title="Live TV"
  className="border w-100 "
  src={`https://score.tresting.com/socket-iframe-21/crickexpo/${channel}`}
  style={{ width: "100%", height: "297px" }}
/>
                      }

                      {/* {role !== 'demo' && token ?
                        (<iframe
                              title="Live TV"
                              className="border w-100 "
                              style={{ height: isLargeScreen ? "28vh" : "33vh" }}
                              // src={`https://score.tresting.com/socket-iframe-17/crickexpo/${eventId}`}
                              src={`https://e765432.diamondcricketid.com/sr.php?eventid=${eventId}&sportid=4`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>) : ""
                      } */}

                      {/* <p
                        className="breadcrumb mt-3"
                        style={{ fontFamily: "sans-serif", color: "grey" }}
                      >
                        Home &gt; Cricket &gt; {competiton} &gt;
                        {event} &gt; Match Odds
                      </p>
                      <span className="text-info fs-7 inline">Start Time: &nbsp;{startTime}</span> */}

                      {/* Which match this is. The page opened straight on
                          "Match Odds" with no teams, competition or start
                          time anywhere on a phone (#12). */}
                      {event && (
                        <header className="rb-match__head" id="rb-match-top">
                          <h1 className="rb-match__title">{event}</h1>
                          <p className="rb-match__meta">
                            {competiton}
                            {competiton && startTime ? " · " : ""}
                            {startTime}
                          </p>
                        </header>
                      )}

                      <div
                        className="match-section mb-1"
                        style={{ color: "var(--dark-theme-color-navbar)" }}
                      >
                        <div
                          className="match-header align-items-end"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-time-remaining)",
                              marginTop: isLargeScreen ? "0px" : "12px",
                            }}
                            className="d-flex mb-1 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              className="py-1 me-3 d-flex fw-bold mb-0 px-2 rad bett"
                            >
                              <span
                                _ngcontent-jrx-c94=""
                                className=""
                                style={{
                                  border:
                                    "1px solid var(--dark-theme-card-bg-light)",
                                  height: "18px",
                                  width: "18px",
                                }}
                              >
                                <i
                                  className="fa fa-thumb-tack"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              Match Odds
                            </p>
                            <p
                              className="d-flex gap-1 ms-auto me-2 mb-0 fszz fw-bold"
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                            >
                              <span
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                          </div>

                          <div
                            className="d-flex gap-1"
                            style={{
                              height: "1.5rem",
                              marginRight: isLargeScreen ? "9rem" : "0.5rem",
                            }}
                          >
                            <p
                              className="fs-6 px-2 mb-0 ms-auto bgInfo"
                              style={{
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "5px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-3 mb-0 bg-pink1"
                              style={{
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "20px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-center border-2 p-1"
                          >
                            <h5
                              className="fs-4 text-wrap run d-flex flex-col"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid1}
                            >
                              <span>{runner1}</span> {""}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner1] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner1]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner1] || 0
                                ) +
                                  parseFloat(oddMatchLiablity || 0) ===
                                0
                                  ? ""
                                  : parseFloat(
                                      matchLiabilities?.odds?.pnl?.[runner1] ||
                                        0
                                    ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div className="d-flex gap-1">
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-red"
                                    : pr === 3 || pr === 17
                                    ? "d-block text-red"
                                    : pr === 4 || pr === 18
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 3 || pr === 17
                                  ? -money
                                  : pr === 4 || pr === 18
                                  ? money
                                  : pr === 1
                                  ? profit
                                  : -profit}
                              </span>

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded fs-6 py-2 h-50 text-center cursor-pointer ${
                                      index < back1.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    onClick={() => {
                                      setbackActive(1);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(1);
                                      setSelectedId(selectionid1);
                                      setRunner(runner1);
                                      setSide("Back");
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`rounded fs-6 py-2 h-50 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    setlayActive(4);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(2);
                                    setSelectedId(selectionid1);
                                    setRunner(runner1);
                                    setSide("Lay");
                                    setSelectedBet(0);
                                  }}
                                  style={{ width: "4rem" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                          >
                            <h5
                              className="fs-4 text-wrap run d-flex flex-col"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid2}
                            >
                              {runner2} {""}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner2] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner2]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {/* {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) + parseFloat(oddMatchLiablity || 0)} */}

                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) +
                                  parseFloat(oddMatchLiablity || 0) ===
                                0
                                  ? ""
                                  : parseFloat(
                                      matchLiabilities?.odds?.pnl?.[runner2] ||
                                        0
                                    ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div className="d-flex gap-1">
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-red"
                                    : pr === 1 || pr === 17
                                    ? "d-block text-red"
                                    : pr === 2 || pr === 18
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 1 || pr === 17
                                  ? -money
                                  : pr === 2 || pr === 18
                                  ? money
                                  : pr === 3
                                  ? profit
                                  : -profit}
                              </span>

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index < back2.length - 1
                                        ? "bgSecondary dnone"
                                        : "bgInfo"
                                    }`}
                                    onClick={() => {
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(3);
                                      setSelectedId(selectionid2);
                                      setSide("Back");
                                      setRunner(runner2);
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`rounded fs-6 py-2 h-100 text-center cursor-pointer ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bgSecondary dnone"
                                  }`}
                                  onClick={() => {
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(4);
                                    setSelectedId(selectionid2);
                                    setSide("Lay");
                                    setRunner(runner2);
                                    setSelectedBet(0);
                                  }}
                                  style={{ width: "4rem" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          {(back3?.length > 0 || lay3?.length > 0) && (
                            <div
                              style={{ borderBottom: "1px solid #d3cece" }}
                              className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                            >
                              <h5
                                className="fs-4 text-wrap run"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                }}
                                id={selectionid3}
                              >
                                {runner3} {""}
                                <span
                                  className={`${
                                    (matchLiabilities?.odds?.pnl?.[runner3] !==
                                    undefined
                                      ? matchLiabilities.odds.pnl[runner3]
                                      : parseFloat(oddMatchLiablity)) < 0
                                      ? "text-red"
                                      : "text-green"
                                  }`}
                                >
                                  {/* {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner3] || 0
                                ) + parseFloat(oddMatchLiablity || 0)} */}

                                  {parseFloat(
                                    matchLiabilities?.odds?.pnl?.[runner3] || 0
                                  ) +
                                    parseFloat(oddMatchLiablity || 0) ===
                                  0
                                    ? ""
                                    : parseFloat(
                                        matchLiabilities?.odds?.pnl?.[
                                          runner3
                                        ] || 0
                                      ) + parseFloat(oddMatchLiablity || 0)}
                                </span>
                              </h5>

                              <div className="d-flex gap-1">
                                <span
                                  className={`${
                                    pr === 17
                                      ? "d-block text-green"
                                      : pr === 18
                                      ? "d-block text-red"
                                      : pr === 1 || pr === 3
                                      ? "d-block text-red"
                                      : pr === 2 || pr === 4
                                      ? "d-block text-green"
                                      : "d-none"
                                  }`}
                                >
                                  {"=>"}
                                  {pr === 1 || pr === 3
                                    ? -money
                                    : pr === 3 || pr === 4
                                    ? -money
                                    : pr === 17
                                    ? profit
                                    : -profit}
                                </span>

                                {back3
                                  .slice()
                                  .reverse()
                                  .map((bc, index) => (
                                    <div
                                      className={`rounded fs-6 py-2 h-100 text-center cursor-pointer ${
                                        index < back3.length - 1
                                          ? "bgSecondary dnone"
                                          : "bgInfo"
                                      }`}
                                      onClick={() => {
                                        setbackActive(3);
                                        setlayActive(3);
                                        setSelectedPrice(bc.price);
                                        setPr(17);
                                        setSelectedId(selectionid3);
                                        setSide("Back");
                                        setRunner(runner3);
                                        setSelectedBet(0);
                                      }}
                                      style={{ width: "4rem" }}
                                    >
                                      {bc.price}
                                    </div>
                                  ))}

                                {lay3.map((bc, index) => (
                                  <div
                                    className={`rounded fs-6 py-2 h-100 text-center cursor-pointer ${
                                      index === 0
                                        ? "bg-pink1"
                                        : "bgSecondary dnone"
                                    }`}
                                    onClick={() => {
                                      setlayActive(6);
                                      setbackActive(0);
                                      setSelectedPrice(bc.price);
                                      setPr(18);
                                      setSelectedId(selectionid3);
                                      setSide("Lay");
                                      setRunner(runner3);
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* betting back div */}
                        {backActive !== 0 && (
                          <div
                            style={{
                              backgroundColor: "var(--dark-theme-data-homebet)",
                              padding: "5px",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            {backLoading ? (
                              // 🔹 Spinner Overlay
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "5px",
                                  zIndex: 10,
                                }}
                              >
                                <div
                                  style={{
                                    border:
                                      "4px solid var(--dark-theme-card-bg-light2)",
                                    borderTop:
                                      "4px solid var(--dark-theme-data-submit)",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                              </div>
                            ) : null}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                marginBottom: "7px",
                              }}
                            >
                              <div>
                                {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handlelayChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={selectedPrice}
                                    onChange={(e) =>
                                      setSelectedPrice(e.target.value)
                                    }
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                      width: "84px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handlelayChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div>
                                {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handleChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={money}
                                    onChange={(e) => setMoney(e.target.value)}
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                      width: "84px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handleChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "3px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div>

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}

                            >
                              <button
                                onClick={() => setMoney(minOdds)}
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                          </div>
                        )}

                        {/* betting lay div */}
                        {layActive !== 3 && (
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-data-homebet2)",
                              padding: "5px",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            {layLoading ? (
                              // 🔹 Spinner Overlay
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "5px",
                                  zIndex: 10,
                                }}
                              >
                                <div
                                  style={{
                                    border:
                                      "4px solid var(--dark-theme-card-bg-light2)",
                                    borderTop:
                                      "4px solid var(--dark-theme-data-submit)",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                              </div>
                            ) : null}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 20px",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div
                                style={{ color: "#4ADE80", fontWeight: "bold" }}
                              >
                                Profit:{" "}
                                {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    marginRight: "8px",
                                  }}
                                  id="matchAtAnyRate"
                                />
                                <label htmlFor="matchAtAnyRate">
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              <div>
                                {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Odds
                                </div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handlelayChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={selectedPrice}
                                    onChange={(e) =>
                                      setSelectedPrice(e.target.value)
                                    }
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      fontSize: "13px",
                                      width: "84px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handlelayChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div>
                                {/* <div
                                  style={{
                                    textAlign: "center",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Stake
                                </div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handleChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={money}
                                    onChange={(e) => setMoney(e.target.value)}
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                      width: "84px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handleChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                            </div>

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(6, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-set2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "normal",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "8px",
                                marginBottom: "8px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxOdds)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-dark-blue-bm)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-stake)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-data-clear)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "8px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(2, 1fr)",
                                gap: "8px",
                              }}
                            >
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-cancel)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setlayActive(3);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: 'var(--dark-theme-data-submit)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div> */}
                          </div>
                        )}

                        {/* bookmaker */}
                        {(
                          <>
                            <div className="align-items-start gap-2 mt-2">
                              <div
                                style={{
                                  backgroundColor:
                                    "var(--dark-theme-time-remaining)",
                                }}
                                className="d-flex flex-lg-row flex-row flex-md-row align-items-baseline"
                              >
                                <p
                                  id="rb-bookmaker"
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 me-3 px-2 rad bett mb-0"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  BookMaker
                                </p>
                                <p
                                  className="d-flex gap-1 me-2 m-0 ms-auto fszz"
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "var(--dark-theme-color-navbar)",
                                    }}
                                  >
                                    Min:{minBookmaker} <span>|</span>{" "}
                                  </span>{" "}
                                  Max:{maxBookmaker}
                                </p>
                                <button
                                  className="btn me-2 btn-info bg-black"
                                  onClick={() =>
                                    setIsExpanded(isExpanded === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded === 1 ? "−" : "+"}
                                </button>
                              </div>

                              {/* Toggle Button */}
                            </div>

                            {/* Wrap the betting options in a conditional render based on isExpanded state */}
                            {isExpanded === 1 && (
                              <div className="betting-options d-flex flex-column">
                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                                >
                                  <h5
                                    className="fs-3 text-wrap run"
                                    style={{
                                      color: "var(--dark-theme-white-color)",
                                    }}
                                  >
                                    {runner2} {""}
                                    {/* {console.log(matchLiabilities.bookmaker,"efje")} */}
                                    <span
                                      className={`${
                                        (matchLiabilities?.bookmaker?.pnl?.[
                                          runner2
                                        ] !== undefined
                                          ? matchLiabilities.bookmaker.pnl[
                                              runner2
                                            ]
                                          : parseFloat(oddMatchLiablity)) < 0
                                          ? "text-red"
                                          : "text-green"
                                      }`}
                                    >
                                      {/* {parseFloat(
                                        matchLiabilities?.bookmaker?.pnl?.[
                                          runner2
                                        ] || 0
                                      ) + parseFloat(oddMatchLiablity || 0)} */}

                                      {parseFloat(
                                        matchLiabilities?.bookmaker?.pnl?.[
                                          runner2
                                        ] || 0
                                      ) +
                                        parseFloat(oddMatchLiablity || 0) ===
                                      0
                                        ? ""
                                        : parseFloat(
                                            matchLiabilities?.bookmaker?.pnl?.[
                                              runner2
                                            ] || 0
                                          ) + parseFloat(oddMatchLiablity || 0)}
                                    </span>
                                  </h5>

                                  {book2?.gstatus === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      {/* ✅ Odds rendering stays same */}
                                      <span
                                        className={`${
                                          pr === 5
                                            ? "d-block text-green"
                                            : pr === 6
                                            ? "d-block text-red"
                                            : pr === 7
                                            ? "d-block text-red"
                                            : pr === 8
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 7
                                          ? -money
                                          : pr === 8
                                          ? money
                                          : pr === 5
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>

                                      {/* Back button */}
                                      {/* <div
      className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold bgSecondary"
      style={{ width: "4rem"}}
     
    >
      {}
    </div>
      <div
      className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold bgSecondary"
      style={{ width: "4rem" }}
     
    >
      {}
    </div> */}
                                       <div
                className="bg-secondary p-2 dnone"
                style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca" }}
              >

              </div>

              {/* back2 - index 1 */}
              <div
                className="bg-secondary p-2 dnone"
                style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca" }}
              >
      
              </div>
                                      <div
                                        className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold "
                                        style={{
                                          width: "4rem",
                                          backgroundColor:
                                            "var(--dark-theme-data-box)",
                                        }}
                                        onClick={() => {
                                         setSelectedBet(3);
                                     setSelectedPrice(book2?.odds[2]?.odds);
                                      setStatus(2);
                                      setPr(5);
                                      setRunner(runner2);
                                      setSelectedId(selectionid2);
                                      setSide("Back");
                                      setbackActive(0);
                                      setlayActive(3);
                                      setBok1lay(book2?.odds[2]?.odds);
                                        }}
                                      >
                                            {book2?.odds[2]?.odds !== 0 ? book2?.odds[2]?.odds : ""}
                                      </div>

                                      {/* Lay button */}
                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        style={{ width: "4rem" }}
                                        onClick={() => {
                                          setSelectedBet(4);
                                       setSelectedPrice(book2?.odds[3]?.odds);
                  setStatus(2);
                  setPr(6);
                  setRunner(book2?.nat || runner1);
                  setSelectedId(selectionid2);
                  setSide("Lay");
                  setbackActive(0);
                  setlayActive(3);
                    setBok1lay(book2?.odds[3]?.odds);
                                        }}
                                      >
                                    {book2?.odds[3]?.odds !== 0 ? book2?.odds[3]?.odds : ""}
                                      </div>

                                     <div
                className="bg-secondary p-2 dnone"
                style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca" }}
              >
            
              </div>

              {/* lay3 - index 5 */}
              <div
                className="bg-secondary p-2 dnone"
                style={{ width: isLargeScreen ? "4rem" : "3.2rem", borderLeft: "1px solid #c7c8ca" }}
              >
         
              </div>
                                      {/* <div
      className="bgSecondary rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
      style={{ width: "4rem" }}
     
    >
      {}
    </div>
      <div
      className="bgSecondary rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
      style={{ width: "4rem" }}
     
    >
      {}
    </div> */}
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {book2?.gstatus}
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                                >
                                  <h5
                                    className="fs-3 text-wrap run"
                                    style={{
                                      color: "var(--dark-theme-white-color)",
                                    }}
                                  >
                                    {runner1} {""}
                                    <span
                                      className={`${
                                        (matchLiabilities?.bookmaker?.pnl?.[
                                          runner1
                                        ] !== undefined
                                          ? matchLiabilities.bookmaker.pnl[
                                              runner1
                                            ]
                                          : parseFloat(oddMatchLiablity)) < 0
                                          ? "text-red"
                                          : "text-green"
                                      }`}
                                    >
                                      {/* {parseFloat(
                                    matchLiabilities?.bookmaker?.pnl?.[
                                      runner1
                                    ] || 0
                                  ) + parseFloat(oddMatchLiablity || 0)} */}

                                      {parseFloat(
                                        matchLiabilities?.bookmaker?.pnl?.[
                                          runner1
                                        ] || 0
                                      ) +
                                        parseFloat(oddMatchLiablity || 0) ===
                                      0
                                        ? ""
                                        : parseFloat(
                                            matchLiabilities?.bookmaker?.pnl?.[
                                              runner1
                                            ] || 0
                                          ) + parseFloat(oddMatchLiablity || 0)}
                                    </span>
                                  </h5>

                                  {book1?.gstatus === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      {/* ✅ Profit/Loss Indicator */}
                                      <span
                                        className={`${
                                          pr === 7
                                            ? "d-block text-green"
                                            : pr === 8
                                            ? "d-block text-red"
                                            : pr === 5
                                            ? "d-block text-red"
                                            : pr === 6
                                            ? "d-block text-green"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 5
                                          ? -money
                                          : pr === 6
                                          ? money
                                          : pr === 7
                                          ? bookmakerProfit
                                          : -bookmakerProfit}
                                      </span>

                                      {/* Back Button */}
                                      {/* <div
      className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold bgSecondary"
      style={{ width: "4rem",}}
     
    >
      {}
    </div>
     <div
      className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold bgSecondary"
      style={{ width: "4rem" }}
     
    >
      {}
    </div> */}
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        style={{
                                          width: "4rem",
                                          backgroundColor:
                                            "var(--dark-theme-data-box)",
                                        }}
                                        onClick={() => {
                                          setSelectedBet(3);
                                        setSelectedPrice(book1?.odds[2]?.odds);
                  setStatus(1);
                  setPr(7);
                  setRunner(book1?.nat || runner2);
                  setSelectedId(selectionid1);
                  setSide("Back");
                  setbackActive(0);
                  setlayActive(3);
                                            setBok1lay(book1?.odds[2]?.odds);
                                        }}
                                      >
                                   {book1?.odds[2]?.odds !== 0 ? book1?.odds[2]?.odds : ""}
                                      </div>

                                      {/* Lay Button */}
                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        style={{ width: "4rem" }}
                                        onClick={() => {
                                          setSelectedBet(4);
                                     setSelectedPrice(book1?.odds[3]?.odds);
                  setStatus(1);
                  setPr(8);
                  setRunner(book1?.nat || runner2);
                  setSelectedId(selectionid1);
                  setSide("Lay");
                  setbackActive(0);
                  setlayActive(3);
                                            setBok1lay(book1?.odds[3]?.odds);
                                        }}
                                      >
                                   {book1?.odds[3]?.odds !== 0 ? book1?.odds[3]?.odds : ""}
                                      </div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      {/* <div
      className="bgSecondary rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
      style={{ width: "4rem" }}
    
    >
      {}
    </div>
       <div
      className="bgSecondary rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
      style={{ width: "4rem" }}
    
    >
      {}
    </div> */}
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {book1?.gstatus}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* bookmaker back and lay active */}
                        {/* betting back div */}
                        {selectedBet === 3 && isExpanded === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor: "var(--dark-theme-data-homebet)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#006688",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{
                                  color: "#4eff4e",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Profit: {bookmakerProfit}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="matchAnyRate"
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label
                                  htmlFor="matchAnyRate"
                                  style={{ color: 'var(--dark-theme-color-navbar)' }}
                                >
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Odds
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Stake
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>

                            {/* Quick amount buttons - second row */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                            {/* Action buttons */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minBookmaker)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxBookmaker)}

                                style={{
                                  backgroundColor: "#183494",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#8a2ca8",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#c92a2a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginTop: "15px",
                              }}
                            >
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#e74c3c",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#2ecc71",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div> */}
                          </div>
                        )}

                        {/* betting lay div */}
                        {selectedBet === 4 && isExpanded === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor:
                                "var(--dark-theme-data-homebet2)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#e6567a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                              >
                                LAY
                              </button>
                              <div
                                style={{
                                  color: "#4eff4e",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Profit: {bookmakerProfit}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="matchAnyRateLay"
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label
                                  htmlFor="matchAnyRateLay"
                                  style={{ color: 'var(--dark-theme-color-navbar)' }}
                                >
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Odds
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Stake
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    width: "84px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  name="mon"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    background:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}

                        {/* mini bookmaker data */}
                        {/* { (
                          <>
                          
                            <>
                              <div className=" align-items-start gap-2 mt-3">
                                <div
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-time-remaining)",
                                  }}
                                  className="d-flex flex-lg-row flex-row flex-md-row align-items-baseline"
                                >
                                  <p
                                    style={{
                                      color: "var(--dark-theme-color-navbar)",
                                    }}
                                    className="py-1 me-3 px-2 rad bett mb-0"
                                  >
                                    <span
                                      _ngcontent-jrx-c94=""
                                      className="me-1"
                                      style={{
                                        border:
                                          "1px solid var(--dark-theme-card-bg-light)",
                                        height: "18px",
                                        width: "18px",
                                      }}
                                    >
                                      <i
                                        className="fa fa-thumb-tack p-1"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                    Mini BookMaker
                                  </p>
                                  <p
                                    className="d-flex gap-1 fszz fw-bold ms-auto m-0"
                                    style={{
                                      color: "var(--dark-theme-color-navbar)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "var(--dark-theme-color-navbar)",
                                      }}
                                    >
                                      Min:{minMiniBook} <span>|</span>{" "}
                                    </span>{" "}
                                    Max:{maxMiniBook}
                                  </p>
                                  <button
                                    className="btn me-4 btn-info bg-black"
                                    onClick={() =>
                                      setIsExpanded1(isExpanded1 === 1 ? 0 : 1)
                                    }
                                    style={{
                                      fontSize: "1.5rem",
                                      lineHeight: 1,
                                    }}
                                  >
                                    {isExpanded1 === 1 ? "−" : "+"}
                                  </button>
                                </div>

                               
                              </div>

                              {isExpanded1 === 1 && (
                                <div className="betting-options d-flex flex-column">
                                  <div
                                    style={{
                                      borderBottom: "1px solid #d3cece",
                                    }}
                                    className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                                  >
                                    <h5
                                      className="fs-3 text-wrap run"
                                      style={{
                                        color: "var(--dark-theme-white-color)",
                                      }}
                                    >
                                      {runner1}
                                    </h5>

                                    {mini1?.status === "ACTIVE" ? (
                                      <div className="d-flex gap-2">
                                        <span
                                          className={`${
                                            pr === 13
                                              ? "d-block text-green"
                                              : pr === 14
                                              ? "d-block text-red"
                                              : pr === 15
                                              ? "d-block text-red"
                                              : pr === 16
                                              ? "d-block text-green"
                                              : "d-none"
                                          }`}
                                        >
                                          {"=>"}
                                          {pr === 15
                                            ? -money
                                            : pr === 16
                                            ? money
                                            : pr === 13
                                            ? bookmakerProfit
                                            : -bookmakerProfit}
                                        </span>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>

                                        <div
                                          className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                            onClick={() => {
                                          setSelectedBet(7);
                                          setSelectedPrice(mini1.back_price);
                                          setStatus(1);
                                          setPr(13);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Back");
                                        }}
                                          style={{
                                            width: "4rem",
                                            backgroundColor:
                                              "var(--dark-theme-data-box)",
                                          }}
                                        >
                                         {mini1.back_price}
                                        </div>

                                        <div
                                          className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                           onClick={() => {
                                          setSelectedBet(8);
                                          setSelectedPrice(mini1.lay_price);
                                          setStatus(1);
                                          setPr(14);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Lay");
                                        }}
                                          style={{ width: "4rem" }}
                                        >
                                          {mini1.lay_price}
                                        </div>

                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                      </div>
                                    ) : (
                                      <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                        {mini1?.status}
                                      </div>
                                    )}
                                  </div>

                                  <div
                                    style={{
                                      borderBottom: "1px solid #d3cece",
                                    }}
                                    className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                                  >
                                    <h5
                                      className="fs-3 text-wrap run"
                                      style={{
                                        color: "var(--dark-theme-white-color)",
                                      }}
                                    >
                                      {runner2}
                                    </h5>

                                    {mini2?.gstatus === "ACTIVE" ? (
                                      <div className="d-flex gap-2">
                                        <span
                                          className={`${
                                            pr === 15
                                              ? "d-block text-green"
                                              : pr === 16
                                              ? "d-block text-red"
                                              : pr === 13
                                              ? "d-block text-red"
                                              : pr === 14
                                              ? "d-block text-green"
                                              : "d-none"
                                          }`}
                                        >
                                          {"=>"}
                                          {pr === 13
                                            ? -money
                                            : pr === 14
                                            ? money
                                            : pr === 15
                                            ? bookmakerProfit
                                            : -bookmakerProfit}
                                        </span>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>

                                        <div
                                          className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                          style={{
                                            width: "4rem",
                                            backgroundColor:
                                              "var(--dark-theme-data-box)",
                                          }}
                                         onClick={() => {
                                          setSelectedBet(7);
                                          setSelectedPrice(mini2.back_price);
                                          setStatus(2);
                                          setPr(15);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Back");
                                        }}
                                        >
                                          {mini2.back_price}
                                        </div>

                                        <div
                                          className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                          style={{ width: "4rem" }}
                                        onClick={() => {
                                          setSelectedBet(8);
                                          setSelectedPrice(mini2.lay_price);
                                          setStatus(2);
                                          setPr(16);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Lay");
                                        }}
                                        >
                                      {mini2.lay_price}
                                        </div>

                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                        <div
                                          className="bg-secondary rounded p-2 dnone"
                                          style={{ width: "4rem" }}
                                        ></div>
                                      </div>
                                    ) : (
                                      <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                        {mini2?.status}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </>
                          </>
                        )} */}

                        {/*mini bookmaker betting back div */}
                        {selectedBet === 7 && isExpanded1 === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor: "var(--dark-theme-data-homebet)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#006688",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                              >
                                BACK
                              </button>
                              <div
                                style={{
                                  color: "#4eff4e",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Profit: {bookmakerProfit}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="matchAnyRate"
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label
                                  htmlFor="matchAnyRate"
                                  style={{ color: 'var(--dark-theme-color-navbar)' }}
                                >
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Odds
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Stake
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>

                            {/* Quick amount buttons - second row */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                            {/* Action buttons */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minBookmaker)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxBookmaker)}

                                style={{
                                  backgroundColor: "#183494",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#8a2ca8",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#c92a2a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginTop: "15px",
                              }}
                            >
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#e74c3c",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#2ecc71",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div> */}
                          </div>
                        )}

                        {/*mini bookmaker betting lay div */}
                        {selectedBet === 8 && isExpanded1 === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor:
                                "var(--dark-theme-data-homebet2)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#e6567a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                              >
                                LAY
                              </button>
                              <div
                                style={{
                                  color: "#4eff4e",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Profit: {bookmakerProfit}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="matchAnyRateLay"
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label
                                  htmlFor="matchAnyRateLay"
                                  style={{ color: 'var(--dark-theme-color-navbar)' }}
                                >
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Odds
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Stake
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    width: "84px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  name="mon"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    background:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 100)
                                }
                              >
                                + 100
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 500)
                                }
                              >
                                + 500
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 1000)
                                }
                              >
                                + 1k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 5000)
                                }
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 10000)
                                }
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setMoney((prevMoney) => prevMoney + 50000)
                                }
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}

                        {/* toss */}
                        {/* { (
                          <>
                            <div
                              className=" d-flex align-items-start gap-2 mt-3"
                              style={{
                                backgroundColor:
                                  "var(--dark-theme-time-remaining)",
                              }}
                            >
                              <div
                                style={{
                                  marginTop: isLargeScreen ? "0px" : "3px",
                                }}
                                className="d-flex mb-1 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                              >
                                <p
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 me-3 d-flex fw-bold my-0 px-2 rad bett"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  Toss
                                </p>
                              </div>

                              <p
                                className="d-flex gap-1 ms-auto me-1 mb-0 fszz fw-bold"
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                  marginTop: isLargeScreen ? "0px" : "3px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                >
                                  Min:{minOdds} <span>|</span>{" "}
                                </span>{" "}
                                Max:{maxOdds}
                              </p>
                              <button
                                className="btn me-4 btn-info bg-black"
                                onClick={() =>
                                  setIsExpanded2(isExpanded2 === 1 ? 0 : 1)
                                }
                                style={{ fontSize: "1.5rem", lineHeight: 1 }}
                              >
                                {isExpanded2 === 1 ? "−" : "+"}
                              </button>
                            </div>
                            {isExpanded2 === 1 && (
                              <div className="betting-options d-flex flex-column p-2 gap-2">
                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center bg-light p-2"
                                >
                                  <h5
                                    className="fs-3 text-wrap run"
                                    style={{
                                      color: "var(--dark-theme-white-color)",
                                    }}
                                  >
                                    {runner1}
                                  </h5>

                                  {toss1?.status === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      <span
                                        className={`${
                                          pr === 9
                                            ? "d-block text-green"
                                            : pr === 10
                                            ? "d-block text-green"
                                            : pr === 11 || pr === 12
                                            ? "d-block text-red"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 11 || pr === 12
                                          ? -money
                                          : bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>

                                      <div
                                        className="rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        onClick={() => {
                                          setSelectedBet(5);
                                          setSelectedPrice(toss1.back_price);
                                          setStatus(1);
                                          setPr(9);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Back");
                                        }}
                                        style={{
                                          width: "4rem",
                                          backgroundColor:
                                            "var(--dark-theme-data-box)",
                                        }}
                                      >
                                        {toss1.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        onClick={() => {
                                          setSelectedBet(6);
                                          setSelectedPrice(toss1.lay_price);
                                          setStatus(1);
                                          setPr(10);
                                          setRunner(runner1);
                                          setSelectedId(selectionid1);
                                          setSide("Lay");
                                        }}
                                        style={{ width: "4rem" }}
                                      >
                                        {toss1.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {toss1?.status}
                                    </div>
                                  )}
                                </div>

                                <div
                                  style={{ borderBottom: "1px solid #d3cece" }}
                                  className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1"
                                >
                                  <h5
                                    className="fs-3 text-wrap run"
                                    style={{
                                      color: "var(--dark-theme-white-color)",
                                    }}
                                  >
                                    {runner2}
                                  </h5>

                                  {toss2?.status === "ACTIVE" ? (
                                    <div className="d-flex gap-2">
                                      <span
                                        className={`${
                                          pr === 11
                                            ? "d-block text-green"
                                            : pr === 12
                                            ? "d-block text-green"
                                            : pr === 9 || pr === 10
                                            ? "d-block text-red"
                                            : "d-none"
                                        }`}
                                      >
                                        {"=>"}
                                        {pr === 9 || pr === 10
                                          ? -money
                                          : bookmakerProfit}
                                      </span>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>

                                      <div
                                        className=" rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold text-black"
                                        style={{
                                          width: "4rem",
                                          backgroundColor:
                                            "var(--dark-theme-data-box)",
                                        }}
                                        onClick={() => {
                                          setSelectedBet(5);
                                          setSelectedPrice(toss2.back_price);
                                          setStatus(2);
                                          setPr(11);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Back");
                                        }}
                                      >
                                        {toss2.back_price}
                                      </div>

                                      <div
                                        className="bg-pink1 rounded p-2 text-center fs-5 cursor-pointer text-black fw-bold"
                                        style={{ width: "4rem" }}
                                        onClick={() => {
                                          setSelectedBet(6);
                                          setSelectedPrice(toss2.lay_price);
                                          setStatus(2);
                                          setPr(12);
                                          setRunner(runner2);
                                          setSelectedId(selectionid2);
                                          setSide("Lay");
                                        }}
                                      >
                                        {toss2.lay_price}
                                      </div>

                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                      <div
                                        className="bg-secondary rounded p-2 dnone"
                                        style={{ width: "4rem" }}
                                      ></div>
                                    </div>
                                  ) : (
                                    <div className="bg-info-pink rounded fs-6 py-2 d-flex justify-content-center align-items-center media">
                                      {toss2?.status}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </>
                        )} */}

                        {/* toss bets */}
                        {/* betting back div */}
                        {selectedBet === 5 && isExpanded2 === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor: "var(--dark-theme-data-homebet)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    backgroundColor:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(100)}
                              >
                                + 100
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(500)}
                              >
                                + 500
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(1000)}
                              >
                                + 1k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>

                            {/* Quick amount buttons - second row */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(25000)}
                              >
                                + 25k
                              </button>
                              <button
                                style={{
                                  backgroundColor: 'var(--dark-theme-card-bg-light2)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                            </div> */}

                            {/* Action buttons */}
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                onClick={() => setMoney(minBookmaker)}

                                style={{
                                  backgroundColor: 'var(--dark-theme-data-min)',
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Min
                              </button>
                              <button
                                onClick={() => setMoney(maxBookmaker)}

                                style={{
                                  backgroundColor: "#183494",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Max
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#8a2ca8",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Edit Stake
                              </button>
                              <button
                                style={{
                                  backgroundColor: "#c92a2a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  width: "24%",
                                  padding: "10px 0",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                Clear
                              </button>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginTop: "15px",
                              }}
                            >
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#e74c3c",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  width: "49%",
                                  padding: "12px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  backgroundColor: "#2ecc71",
                                  color: 'var(--dark-theme-color-navbar)',
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div> */}
                          </div>
                        )}

                        {/* betting lay div */}
                        {selectedBet === 6 && isExpanded2 === 1 && (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "1000px",
                              backgroundColor:
                                "var(--dark-theme-data-homebet2)",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "8px",
                              padding: "5px",
                              margin: "0 auto",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                marginBottom: "7px",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#e6567a",
                                  color: 'var(--dark-theme-color-navbar)',
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                              >
                                LAY
                              </button>
                              <div
                                style={{
                                  color: "#4eff4e",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {" "}
                                Profit: {bookmakerProfit}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="matchAnyRateLay"
                                  style={{ width: "18px", height: "18px" }}
                                />
                                <label
                                  htmlFor="matchAnyRateLay"
                                  style={{ color: 'var(--dark-theme-color-navbar)' }}
                                >
                                  Match At Any Rate
                                </label>
                              </div>
                            </div> */}

                            {/* <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                marginBottom: "7px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Odds
                              </div>
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  width: "48%",
                                }}
                              >
                                Stake
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {/* Odds input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handlelayChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  style={{
                                    flex: 1,
                                    backgroundColor:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    width: "84px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              {/* Stake input */}
                              <div
                                style={{
                                  display: "flex",
                                  height: "30px",
                                }}
                              >
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "5px 0 0 5px",
                                  }}
                                  onClick={() => handleChange(0)}
                                >
                                  −
                                </button>
                                <input
                                  type="text"
                                  name="mon"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  style={{
                                    flex: 1,
                                    background:
                                      "var(--dark-theme-color-navbar)",
                                    color: "var(--dark-theme-white-color)",
                                    border: "none",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    height: "100%",
                                    width: "84px",
                                  }}
                                />
                                <button
                                  style={{
                                    background:
                                      "var(--dark-theme-card-bg-light2)",
                                    color: "var(--dark-theme-color-navbar)",
                                    border: "none",
                                    width: "22px",
                                    height: "100%",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    borderRadius: "0 5px 5px 0",
                                  }}
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>

                            {/* Quick amount buttons - first row */}
                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(100)}
                              >
                                + 100
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(500)}
                              >
                                + 500
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(1000)}
                              >
                                + 1k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  border: "none",
                                  padding: "5px 0",
                                  textAlign: "center",
                                  borderRadius: "5px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => {
                                  setSelectedBet(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "5px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                onClick={() => handleSubmit2()}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}

                        {/* fancy market */}
                        <div className="match-header align-items-start mt-0 w-100 mb-5">
                          <div
                            style={{
                              backgroundColor: "var(--dark-theme-data-box)",
                            }}
                            className="d-flex align-items-baseline w-100 pt-2"
                          >
                            <p
                              id="rb-fancy"
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              className="py-1 me-5 px-2 rad bett mb-0"
                            >
                              <span
                                _ngcontent-jrx-c94=""
                                className="me-1"
                                style={{
                                  border:
                                    "1px solid var(--dark-theme-card-bg-light)",
                                  height: "18px",
                                  width: "18px",
                                }}
                              >
                                <i
                                  className="fa fa-thumb-tack p-1"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              Fancy Markets
                            </p>

                            {/* <div
                              className="d-flex align-items-end gap-5 ms-0 m-0 ms-md-auto me-4 pr-3"
                              style={{ height: "2.5rem" }}
                            >
                              <p
                                style={{
                                  color: "#faa9ba",
                                }}
                                className="fs-5 mb-1"
                              >
                                No
                              </p>
                              <p
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                                className="fs-5 mb-1"
                              >
                                Yes
                              </p>
                            </div> */}
                          </div>

                          <div className="bg-light rounded gap-2 d-flex px-3 py-2 d-flex align-items-baseline w-100 pt-2 overflow-auto">
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 0 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(0)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              ALL
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 1 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(1)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              SESSION
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet text-nowrap ${
                                newactive === 2 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(2)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              W/P MARKET
                            </div>
                            <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${
                                newactive === 3 ? "colr" : ""
                              }`}
                              onClick={() => setNewActive(3)}
                              style={{
                                border: "1px solid var(--dark-theme-data-box)",
                              }}
                            >
                              ODD/EVEN
                            </div>
                            {/* <div
                              className={`rounded text-center px-4 py-1 cursor-pointer bet ${newactive === 4 ? "colr" : ""
                                }`}
                              onClick={() => setNewActive(6)}
                              style={{ border: '1px solid var(--dark-theme-data-box)' }}
                            >
                              XTRA
                            </div> */}
                          </div>

                        

                          {/* session */}
                          {Array.isArray(session) &&
                          session.length > 0 &&
                           (newactive === 0 || newactive === 1)? (
                            <div className="d-flex flex-column align-items-baseline w-100">
                              {/* Add your heading here */}

                              <div
                                style={{
                                  backgroundColor: "var(--dark-theme-data-box)",
                                }}
                                className="gappp"
                              >
                                <p
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 px-2 rad bett mb-0 mt-2"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  Session
                                </p>
                                <button
                                  className="btn ms-auto me-4 btn-info"
                                  onClick={() =>
                                    setIsExpanded3(isExpanded3 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded3 === 1 ? "−" : "+"}
                                </button>
                              </div>

                              {isExpanded3 === 1 && (
                                <div className="w-100">

                              {  console.log('session',session)}
                             {session.map((item, index) => {
  return item?.section?.map((runner, i) => {

    const natText = runner?.nat?.toLowerCase() || "";

    const isOverRuns =
      (natText.includes("over") || natText.includes("ov")) &&
      natText.includes("run");

    // ❌ skip everything if not over runs
    if (!isOverRuns) return null;

    const uniqueIndex = `${index}-${i}`;

    const oddsMap = Object.fromEntries(
      (runner?.odds || []).map(o => [o.oname, o])
    );

    const nat = runner?.nat || "-";

    const odds1 = oddsMap?.back1?.odds || "-";
    const odds2 = oddsMap?.lay1?.odds || "-";

    const size1 = oddsMap?.back1?.size || "-";
    const size2 = oddsMap?.lay1?.size || "-";

    const status = runner?.gstatus;

    const matchingBet = fancyBetData.find(
      (fb) => fb.runnerName === nat
    );

    const betAmount = matchingBet?.betAmount || "";

    const overallPosition = calculateOverallPosition(
      nat,
      fancyBetData
    );

    // 👇 return your JSX here
                                    return (
                                      <div key={uniqueIndex} className="w-100">
                                        <div
                                          style={{
                                            borderBottom: "1px solid #d3cece",
                                          }}
                                          className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1 w-100"
                                        >
                                          <h5
                                            className="mb-3 mb-md-0 text-wrap run"
                                            style={{
                                              color:
                                                "var(--dark-theme-white-color)",
                                            }}
                                          >
                                              {nat}
                                          </h5>

                                          <div className="d-flex gap-2">
                                            <span className="text-red fw-bold">
                                              {overallPosition.loss < 0
                                                ? overallPosition.loss
                                                : ""}
                                            </span>
                                            <span className="text-green fw-bold">
                                              {overallPosition.profit > 0
                                                ? overallPosition.profit
                                                : ""}
                                            </span>
                                            {/* <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              onClick={() => {
                                                setModalData(matchingBet); // pass your matchingData
                                                setModal(true);
                                                setnat(nat);
                                              }}
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            /> */}

                                            {status === "ACTIVE" || status === ""  ? (
                                              <>
                                                <div
                                                  className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                     onClick={() => {
                                                 
              

                    setSelectedMarket(odds2);
                    setFancyXtra(index);
                    setSelectedBet(1);
                    setFancyBet(uniqueIndex);

                    setStake(size2);

                    setSelectFancy(nat);
                    setSide("no");

                    setFancyValue(odds2);
                    setFancySrno(item.mid);

                    setbackActive(0);
                    setlayActive(3);

                    setSelectedPrice(odds2);
                                                }}
                                                >
                                                     {/* { console.log('nat',nat,'odds1',odds1,'odds2',odds2,'size1',size1,'size2',size2,'status',status)} */}
                                                  <span className="fonts text-black text-bold">
                                                     {odds2}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                    {size2}
                                                  </span>
                                                </div>

                                                <div
                                                  className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                    onClick={() => {
                                              setSelectedMarket(odds1);
                                                  setFancyBet(index);
                                                  setSelectedBet(2);
                                                  setFancyBet(uniqueIndex);
                                                     setStake(size1);
                                               setSelectFancy(nat);
                                                  setSide("yes");
                                                   setFancyValue(odds1);
                    setFancySrno(item.mid);
                                                }}
                                                >
                                                  <span className="fonts text-black text-bold">
                                                     {odds1}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                    {
                                                    size1
                                                  }
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {status}
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {/* fancy betting back div */}

                                       {/* { console.log('fancyBet',fancyBet,'selectedBet',selectedBet,'item.status',item.status,'index',index)} */}
                                        {fancyBet === uniqueIndex &&
                                          selectedBet === 1 &&
                                          (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet2)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy1Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Stake
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}

                                        {/* betting lay div */}
                                        {fancyBet === uniqueIndex &&
                                          selectedBet === 2 &&
                                          (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy2Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Stake
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}
                                      </div>
                                    );
                             })      })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* wpmakrket */}

                          {/* {console.log(wpMarket,"lklk")} */}
                          {Array.isArray(wpMarket) &&
                          wpMarket.length > 0 &&
                          newactive === 2 ? (
                            <div className="align-items-baseline w-100">
                              {/* Add your heading here */}
                              <div
                                style={{
                                  backgroundColor: "var(--dark-theme-data-box)",
                                }}
                                className="d-flex  flex-row gappp"
                              >
                                <p
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 px-3 rad bett mt-2 mb-0"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  WP Market
                                </p>
                                <button
                                  className="btn ms-auto me-4 btn-info"
                                  onClick={() =>
                                    setIsExpanded4(isExpanded4 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded4 === 1 ? "−" : "+"}
                                </button>
                              </div>
                              {isExpanded4 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {wpMarket.map((item, index) => {
                                   return  item?.section?.map((runner, i) => {

                                            const uniqueIndex = `${index}-${i}`;
                                       const oddsMap = Object.fromEntries(
      (runner?.odds || []).map(o => [o.oname, o])
    );

    const nat = runner?.nat || "-";

    const odds1 = oddsMap?.back1?.odds || "-";
    const odds2 = oddsMap?.lay1?.odds || "-";

    const size1 = oddsMap?.back1?.size || "-";
    const size2 = oddsMap?.lay1?.size || "-";

    const status = runner?.gstatus;

                                    // Find matching fancy bet data by runnerName
                                    const matchingBet = fancyBetData.find(
                                      (fb) => fb.runnerName === nat
                                    );

                                    const betAmount =
                                      matchingBet?.betAmount || "";
                                    const overallPosition =
                                      calculateOverallPosition(
                                        nat,
                                        fancyBetData
                                      );
                                    return (
                                      <div key={uniqueIndex} className="w-100 mb-0">
                                        <div
                                          style={{
                                            borderBottom: "1px solid #d3cece",
                                          }}
                                          className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1 w-100 mb-0"
                                        >
                                          <h5
                                            className="mb-3 mb-md-0 text-wrap run"
                                            style={{
                                              color:
                                                "var(--dark-theme-white-color)",
                                            }}
                                          >
                                           {nat}
                                          </h5>

                                          <div className="d-flex gap-2">
                                            <span className="text-red fw-bold">
                                              {overallPosition.loss < 0
                                                ? overallPosition.loss
                                                : ""}
                                            </span>
                                            <span className="text-green fw-bold">
                                              {overallPosition.profit > 0
                                                ? overallPosition.profit
                                                : ""}
                                            </span>
                                            {/* <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              onClick={() => {
                                                setModalData(matchingBet); // pass your matchingData
                                                setModal(true);
                                                setnat(nat);
                                              }}
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            /> */}

                                            {status === "ACTIVE" || status === "ACTIVE" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                     onClick={() => {
                                                  setSelectedMarket(odds2);
                                                  setFancyBet(uniqueIndex);
                                                  setSelectedBet(13);
                                                   setStake(size2);
                                                 setSelectFancy(nat);
                                                  setSide("no");
                                                  setFancyValue(odds2);
                                                  setFancySrno(item.mid);
                                                }}
                                                >
                                                  <span className="fonts text-black text-bold">
  {odds2}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                    {size2}
                                                  </span>
                                                </div>

                                                <div
                                                  className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                     onClick={() => {
                                                 setSelectedMarket(odds1);
                                                  setFancyBet(uniqueIndex);
                                                  setSelectedBet(14);
                                                  setStake(size1);
                                                 setSelectFancy(nat);
                                                  setSide("yes");
                                                 setFancyValue(odds1);
                                                   setFancySrno(item.mid);
                                                }}
                                                >
                                                  <span className="fonts text-black text-bold">
                                                  {odds1}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                  {
                                                   size1
                                                  }
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {status}
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {/* fancy betting back div */}
                                        {fancymarket === uniqueIndex &&
                                          selectedBet === 13 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet2)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy1Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}

                                        {/* betting lay div */}
                                        {fancymarket === uniqueIndex &&
                                          selectedBet === 14 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy2Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Stake
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}
                                      </div>
                                    );
                              })      })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* odd even */}
                          {Array.isArray(oddEven) &&
                          oddEven.length > 0 &&
                            (newactive === 0 || newactive === 3)? (
                            <div className="align-items-baseline w-100 mt-0">
                              {/* Add your heading here */}
                              <div
                                style={{
                                  backgroundColor: "var(--dark-theme-data-box)",
                                }}
                                className="d-flex  flex-row gappp"
                              >
                                <p
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 px-3 rad bett my-auto"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  ODD/EVEN
                                </p>
                                <button
                                  className="btn ms-auto me-4 btn-info"
                                  onClick={() =>
                                    setIsExpanded6(isExpanded6 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded6 === 1 ? "−" : "+"}
                                </button>
                              </div>
                              {isExpanded6 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {oddEven.map((item, index) => {
                                    return  item?.section?.map((runner, i) => {
                                       const uniqueIndex = `${index}-${i}`;
                                      const oddsMap = Object.fromEntries(
      (runner?.odds || []).map(o => [o.oname, o])
    );

    const nat = runner?.nat || "-";

    const odds1 = oddsMap?.back1?.odds || "-";
    const odds2 = oddsMap?.lay1?.odds || "-";

    const size1 = oddsMap?.back1?.size || "-";
    const size2 = oddsMap?.lay1?.size || "-";

    const status = runner?.gstatus;


                                    // Find matching fancy bet data by runnerName
                                    const matchingBet = fancyBetData.find(
                                      (fb) => fb.runnerName === nat
                                    );

                                    const betAmount =
                                      matchingBet?.betAmount || "";
                                    const overallPosition =
                                      calculateOverallPosition(
                                        nat,
                                        fancyBetData
                                      );
                                    return (
                                      <div key={uniqueIndex} className="w-100">
                                        <div
                                          style={{
                                            borderBottom: "1px solid #d3cece",
                                          }}
                                          className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1 w-100 mb-0"
                                        >
                                          <h5
                                            className="mb-3 mb-md-0 text-wrap run"
                                            style={{
                                              color:
                                                "var(--dark-theme-white-color)",
                                            }}
                                          >
                                         {nat}
                                          </h5>

                                          <div className="d-flex gap-2">
                                            <span className="text-red fw-bold">
                                              {overallPosition.loss < 0
                                                ? overallPosition.loss
                                                : ""}
                                            </span>
                                            <span className="text-green fw-bold">
                                              {overallPosition.profit > 0
                                                ? overallPosition.profit
                                                : ""}
                                            </span>
                                            {/* <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              onClick={() => {
                                                setModalData(matchingBet); // pass your matchingData
                                                setModal(true);
                                                setnat(nat);
                                              }}
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            /> */}

                                            {status === "ACTIVE"  || status === "" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}


                                                  onClick={() => {
                                                   setSelectedMarket(odds2);
                                                   setFancyOdd(uniqueIndex); 
                                                  setSelectedBet(10);
                                                      setStake(size2);
                                                     setSelectFancy(nat);
                                                  setSide("no");
                                                      setFancyValue(odds2);

                                                 setFancySrno(item.mid);
                                                }}

                                                     
                                                >
                                                  <span className="fonts text-black text-bold">
                                                             {odds2}

                                                  </span>
                                                  <span className="text-black fs-8">
                                                 {size2}
                                                  </span>
                                                </div>

                                                <div
                                                  className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                   

                                                 onClick={() => {
                                                 setSelectedMarket(odds1);
                                                   setFancyOdd(uniqueIndex); 
                                                  setSelectedBet(9);
                                                      setStake(size1);
                                                  setSelectFancy(nat);
                                                  setSide("yes");
                                                  setFancyValue(odds1);

                                                      setFancySrno(item.mid);
                                                }}
                                                >
                                                  <span className="fonts text-black text-bold">
   {odds1}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                                                        {
                                                   size1
                                                  }
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {status}
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {/* fancy betting back div */}
                                        {fancyOdd === uniqueIndex &&
                                          selectedBet === 9 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet2)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy1Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}

                                        {/* betting lay div */}
                                        {fancyOdd === uniqueIndex &&
                                          selectedBet === 10 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy2Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={`${selectedMarket} (${rate})`}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Stake
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 5000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 5k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 10000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 10k
                                              </div>
                                              <div
                                                className=" rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() =>
                                                  setStake(
                                                    parseInt(stake) + 50000
                                                  )
                                                }
                                                style={{
                                                  background:
                                                    'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                + 50k
                                              </div>
                                              <div
                                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                onClick={() => handleSubmit3()}
                                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "5px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 1 }}
                                              >
                                                Min
                                              </div>
                                              <div
                                                className="bg-primary rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Max
                                              </div>
                                              <div
                                                className="bg-bue rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                }}
                                                style={{
                                                  background: 'var(--dark-theme-data-set2)',
                                                  flex: 1,
                                                }}
                                              >
                                                Edit Stake
                                              </div>
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Clear
                                              </div>
                                            </div> */}

                                              {/* <div className="d-flex justify-content-between gap-2">
                                              <div
                                                className="bg-danger rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => {
                                                  setSelectedBet(0);
                                                  setStake(0);
                                                }}
                                                style={{ flex: 1 }}
                                              >
                                                Cancel
                                              </div>
                                              <div
                                                className="rounded p-2 text-white text-center fw-bold cursor-pointer"
                                                onClick={() => handleSubmit3()}
                                                style={{ backgroundColor: 'var(--dark-theme-data-min)', flex: 3 }}
                                              >
                                                Submit
                                              </div>
                                            </div> */}
                                            </div>
                                          )}
                                      </div>
                                    );
                                  })  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}

                          {/* xtra */}
                          {/* {console.log(fancy, "xtra")} */}
                          {Array.isArray(fancy) &&
                          fancy.length > 0 &&
                          newactive === 4 ? (
                            <div className="align-items-baseline w-100">
                              {/* Add your heading here */}
                              <div
                                style={{
                                  backgroundColor: "var(--dark-theme-data-box)",
                                }}
                                className="d-flex  flex-row gappp"
                              >
                                <p
                                  style={{
                                    color: "var(--dark-theme-color-navbar)",
                                  }}
                                  className="py-1 px-3 rad bett my-auto"
                                >
                                  <span
                                    _ngcontent-jrx-c94=""
                                    className="me-1"
                                    style={{
                                      border:
                                        "1px solid var(--dark-theme-card-bg-light)",
                                      height: "18px",
                                      width: "18px",
                                    }}
                                  >
                                    <i
                                      className="fa fa-thumb-tack p-1"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  XTRA
                                </p>
                                <button
                                  className="btn ms-auto me-4 btn-info"
                                  onClick={() =>
                                    setIsExpanded5(isExpanded5 === 1 ? 0 : 1)
                                  }
                                  style={{ fontSize: "1.5rem", lineHeight: 1 }}
                                >
                                  {isExpanded5 === 1 ? "−" : "+"}
                                </button>
                              </div>

                              {isExpanded5 === 1 && (
                                <div className="w-100">
                                  {/* Map through wpMarket */}
                                  {fancy.map((item, index) => {
                                  return     item?.section?.map((runner, i) => {
                                     const uniqueIndex = `${index}-${i}`;
                                     const oddsMap = Object.fromEntries(
      (runner?.odds || []).map(o => [o.oname, o])
    );

    const nat = runner?.nat || "-";

    const odds1 = oddsMap?.back1?.odds || "-";
    const odds2 = oddsMap?.lay1?.odds || "-";

    const size1 = oddsMap?.back1?.size || "-";
    const size2 = oddsMap?.lay1?.size || "-";

    const status = runner?.gstatus;

                                    // Find matching fancy bet data by runnerName
                                    const matchingBet = fancyBetData.find(
                                      (fb) => fb.runnerName === nat
                                    );

                                    const betAmount =
                                      matchingBet?.betAmount || "";
                                    const overallPosition =
                                      calculateOverallPosition(
                                        nat,
                                        fancyBetData
                                      );

                                    return (
                                      <div key={uniqueIndex} className="w-100">
                                        <div
                                          style={{
                                            borderBottom: "1px solid #d3cece",
                                          }}
                                          className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-md-center p-1 w-100 mb-0"
                                        >
                                          <h5
                                            className="mb-3 mb-md-0 text-wrap run"
                                            style={{
                                              color:
                                                "var(--dark-theme-white-color)",
                                            }}
                                          >
                                          {nat}
                                          </h5>

                                          <div className="d-flex gap-2">
                                            {/* <img
                                              className="small-grid ng-star-inserted mt-4 heig"
                                              onClick={() => {
                                                setModalData(matchingBet); // pass your matchingData
                                                setModal(true);
                                                setnat(nat);
                                              }}
                                              src="/assets/images/ladder.svg"
                                              alt="TVKheloyaar360"
                                            /> */}

                                            {status === "ACTIVE" || status === "" ? (
                                              <>
                                                <div
                                                  className="bg-pink1 rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}


                                                   onClick={() => {
                                                  setSelectedMarket(odds2);
                                                  setFancyXtra(uniqueIndex);
                                                  setSelectedBet(12);
                                                        setStake(size2);
                                                  setSelectFancy(nat);
                                                  setSide("no");
                                                    setFancyValue(odds2);
                                                  setFancySrno(item.mid);
                                                }}

                                                  
                                                >
                                                  <span className="fonts text-black text-bold">
                                                   {odds2}
                                                  </span>
                                                  <span className="text-black fs-8">
                                                    {size2}
                                                  </span>
                                                </div>

                                                <div
                                                  className="bg-info rounded d-flex flex-column px-3 text-center cursor-pointer"
                                                  style={{ width: "70px" }}
                                                 


                                                 onClick={() => {
                                                   setSelectedMarket(odds1);
                                                  setFancyXtra(uniqueIndex);
                                                  setSelectedBet(11);
                                                   setStake(size1);
                                                   setSelectFancy(nat);
                                                  setSide("yes");
                                                  setFancyValue(odds1);

                                                  setFancySrno(item.mid);
                                                }}
                                                >
                                                  <span className="fonts text-black text-bold">
                                                  {odds1}
                                                  </span>
                                                  <span className="text-black fs-8">
                                            {
                                                 size1
                                                  }
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              <div className="bg-info-pink rounded p-2 d-flex flex-column px-3 fonts d-flex align-items-center fw-bold">
                                                {item?.status}
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {/* fancy betting back div */}
                                        {fancyXtra === uniqueIndex &&
                                          selectedBet === 13 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet2)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy1Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  {/* <div className="text-white mb-1">
                                                  Odds
                                                </div> */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedMarket}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>

                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set2)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>
                                            </div>
                                          )}

                                        {/* betting lay div */}
                                        {fancyXtra === uniqueIndex &&
                                          selectedBet === 14 && (
                                            <div
                                              style={{
                                                backgroundColor:
                                                  "var(--dark-theme-data-homebet)",
                                                padding: "5px",
                                                color:
                                                  "var(--dark-theme-color-navbar)",
                                                borderRadius: "5px",
                                                width: "100%",
                                              }}
                                            >
                                              {fancy2Loading ? (
                                                // 🔹 Spinner Overlay
                                                <div
                                                  style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor:
                                                      "rgba(0, 0, 0, 0.5)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    borderRadius: "5px",
                                                    zIndex: 10,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      border:
                                                        "4px solid var(--dark-theme-card-bg-light2)",
                                                      borderTop:
                                                        "4px solid var(--dark-theme-data-submit)",
                                                      borderRadius: "50%",
                                                      width: "32px",
                                                      height: "32px",
                                                      animation:
                                                        "spin 1s linear infinite",
                                                    }}
                                                  />
                                                </div>
                                              ) : null}
                                              {/* First Row - Odds and Stake inputs */}
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  gap: "5px",
                                                  marginBottom: "5px",
                                                }}
                                              >
                                                {/* Odds Section */}
                                                <div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(0)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={selectedMarket}
                                                      onChange={(e) =>
                                                        setSelectedMarket(
                                                          e.target.value
                                                        )
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                      onClick={() =>
                                                        handlefancyChange(1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>

                                                {/* Stake Section */}
                                                <div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      height: "30px",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "4px 0 0 4px",
                                                      }}
                                                      onClick={() =>
                                                        handleChangeStake(1)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      value={stake}
                                                      onChange={(e) =>
                                                        setStake(e.target.value)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-color-navbar)",
                                                        color:
                                                          "var(--dark-theme-white-color)",
                                                        width: "84px",
                                                        border: "none",
                                                        flex: 1,
                                                        textAlign: "center",
                                                        fontSize: "13px",
                                                      }}
                                                    />
                                                    <button
                                                      onClick={() =>
                                                        handleChangeStake(0)
                                                      }
                                                      style={{
                                                        backgroundColor:
                                                          "var(--dark-theme-card-bg-light2)",
                                                        color:
                                                          "var(--dark-theme-color-navbar)",
                                                        width: "22px",
                                                        border: "none",
                                                        fontSize: "13px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        borderRadius:
                                                          "0 4px 4px 0",
                                                      }}
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Second Row - Quick Add Buttons for First Row */}
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gridTemplateColumns:
                                                    isLargeScreen
                                                      ? "repeat(12, 1fr)"
                                                      : "repeat(6, 1fr)",
                                                  gap: "5px",
                                                  marginBottom: "0px",
                                                }}
                                              >
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 100
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 100
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 500
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 500
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 1000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 1k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 5000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 5k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 10000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 10k
                                                </button>
                                                <button
                                                  className="border-0 rounded px-0 py-1 text-white text-center fw-bold cursor-pointer"
                                                  onClick={() =>
                                                    setStake(
                                                      parseInt(stake) + 50000
                                                    )
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-set)",
                                                    flex: 1,
                                                  }}
                                                >
                                                  + 50k
                                                </button>
                                                <button
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-cancel)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                  onClick={() => {
                                                    setSelectedBet(0);
                                                    setStake(0);
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    handleSubmit3()
                                                  }
                                                  style={{
                                                    background:
                                                      "var(--dark-theme-data-submit)",
                                                    color:
                                                      "var(--dark-theme-color-navbar)",
                                                    padding: "5px 0",
                                                    border: "none",
                                                    borderRadius: "3px",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Submit
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    );
                           })         })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <p className="text-white"></p>
                          )}
                        </div>

                        {modal && (
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100vw",
                              height: "100vh",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 1000,
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#000",
                                padding: "20px",
                                borderRadius: "8px",
                                minWidth: "400px",
                                textAlign: "center",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <h4 className="text-start">{nat}</h4>
                                <button
                                  className="bg-danger border-0 rounded px-3 text-white fs-5"
                                  onClick={() => setModal(false)}
                                >
                                  &times;
                                </button>
                              </div>

                              <table className="table mt-3">
                                <thead>
                                  <tr>
                                    <th>Runs</th>
                                    <th>Position</th>
                                  </tr>
                                </thead>

                                {generateModalTableData(
                                  nat,
                                  fancyBetData
                                ).map((row, index) => (
                                  <tr key={index}>
                                    <td className="fs-5">{row.rate}</td>
                                    <td
                                      className={`fs-5 ${
                                        row.position >= 0
                                          ? "text-green"
                                          : "text-red"
                                      }`}
                                    >
                                      {row.position}
                                    </td>
                                  </tr>
                                ))}
                                <tbody></tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="bets-container d-flex flex-column betTv gap-2">
                      {role !== "demo" && token && (
                        <div className="d-none d-lg-block position-relative pl-1">
                          <div
                            className="p-2 cursor-pointer d-flex justify-content-between bg-black"
                            onClick={() => setPlay(!play)}
                          >
                            <div>
                              <span>
                                <i
                                  className="bi bi-broadcast fs-16"
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                  }}
                                ></i>
                              </span>
                              <span> Watch Live Match</span>
                            </div>
                            <div>
                              <button className="live-stream-button ng-star-inserted">
                                Watch Live
                              </button>
                            </div>
                          </div>

                          {play && channel && (
                            <iframe
                              title="Live TV"
                              className="border w-100 h-75"
                              // src={`https://cache.bpexchanges.com/embed?eventId=${channel}`}
                              src={`/proxy-stream/${channel}`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
                          )}
                        </div>
                      )}

                      <div
                        className={` mt-3 mt-lg-0 ms-0 ms-lg-1 mb-4  h-100 w-100 ${isAuthenticated ? "" : "d-none"}`}
                        style={{
                          maxHeight: "100vh",
                          height: `${betData.length * 6}vh`,
                        }}
                      >
                        <div
                          className="m-0 px-2 py-1 bett w-100"
                          style={{
                            background: "var(--dark-theme-bg)",
                            color: "var(--rb-text)",
                          }}
                        >
                          My Bets
                        </div>

                        {/* <table
                          className=" border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: "black",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Unmatched bets
                            </div>
                            <tr>
                              <th className="text-dark">Runner Name</th>
                              <th className="text-dark">ODDS</th>
                              <th className="text-dark">Bet Amount</th>
                              <th className="text-dark">P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {unmatch?.length > 0 ? (
                              unmatch?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td>{bet.betprice}</td>
                                  <td>{bet.betAmount}</td>
                                  <td>{bet.profit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table> */}
                        <table
                          className="border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            {/* <div
                              style={{
                                color: "black",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Matched bets
                            </div> */}
                            <tr className="text-black">
                              <th className="headerColor">Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>Side</th>
                              {/* <th>P/L</th> */}
                            </tr>
                          </thead>

                          <tbody>
                            {/* Sports Bets */}
                            {betData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={5}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Sports Bets
                                  </th>
                                </tr>
                                {betData?.map((bet, index) => (
                                  <tr
                                    key={`sports-${index}`}
                                    className="boder border-black"
                                    style={{
                                      backgroundColor:
                                        bet?.side === "Back"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    <td>
                                      {bet.runnerName} ({bet.type})
                                    </td>
                                    <td>{bet?.betprice}</td>
                                    <td>{bet?.betAmount}</td>
                                    <td>{bet?.side}</td>
                                    {/* <td>{bet?.profit}</td> */}
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={5}
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                    textAlign: "center",
                                  }}
                                >
                                  No sports bet data
                                </td>
                              </tr>
                            )}

                            {/* Fancy Bets */}
                            {fancyBetData?.length > 0 ? (
                              <>
                                <tr>
                                  <th
                                    colSpan={5}
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                    }}
                                  >
                                    Fancy Bets
                                  </th>
                                </tr>
                                {fancyBetData.map((bet, index) => (
                                  <tr
                                    key={`fancy-${index}`}
                                    className="boder border-black"
                                    style={{
                                      backgroundColor:
                                        bet?.side === "yes"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    <td>{`${bet.runnerName}-(${bet.rate})`}</td>
                                    <td>{bet.betprice}</td>
                                    <td>{bet.betAmount}</td>
                                    <td>{bet.side}</td>
                                    {/* <td>{bet.profit}</td> */}
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td
                                  colSpan={5}
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                    textAlign: "center",
                                  }}
                                >
                                  No fancy bet data
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div>
          </app-landing-page-new>
        </div>
      </app-root>
    </>
  );
};

export default Cricket;
